/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  /** @deprecated use ExternalAccountResponse.accountName instead */
  accountName: Scalars['String']['output'];
  /** @deprecated use ExternalAccountResponse.accountSubtype instead */
  accountSubtype: Scalars['String']['output'];
  /** @deprecated use ExternalAccountResponse.bankName instead */
  bankName: Scalars['String']['output'];
  /** @deprecated use HighnoteExternalAccountResponse instead */
  highnoteExternalAccountId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated use ExternalAccountResponse.id instead. or, if you know which one you need, Account.highnoteExternalAccountId or Account.plaidAccountId */
  id: Scalars['ID']['output'];
  /** @deprecated use ExternalAccountResponse.isVerified instead */
  isVerified: Scalars['Boolean']['output'];
  /** @deprecated use ExternalAccountResponse.last4 instead */
  last4: Scalars['String']['output'];
  /** @deprecated use HighnoteExternalAccountResponse instead */
  plaidAccountId?: Maybe<Scalars['ID']['output']>;
  products: Array<Products>;
  status?: Maybe<PlaidItemStatus>;
};

export enum AccountHolderApplicationStatusCode {
  Approved = 'Approved',
  Closed = 'Closed',
  Denied = 'Denied',
  InReview = 'InReview',
  Pending = 'Pending'
}

export type AccountModel = {
  __typename?: 'AccountModel';
  id: Scalars['String']['output'];
  mask: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subtype: Scalars['String']['output'];
  type: Scalars['String']['output'];
  verificationStatus: AccountVerificationStatus;
};

export enum AccountVerificationStatus {
  PendingSystemAction = 'PENDING_SYSTEM_ACTION',
  PendingUserAction = 'PENDING_USER_ACTION',
  VerificationFailed = 'VERIFICATION_FAILED',
  Verified = 'VERIFIED'
}

export type AddMortgageAddressResponseDto = {
  __typename?: 'AddMortgageAddressResponseDto';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  plaidAccountId?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddMortgageLeadErrorModel = {
  __typename?: 'AddMortgageLeadErrorModel';
  errorMessage: Scalars['String']['output'];
};

export type AddMortgageLeadInput = {
  address?: InputMaybe<AddressInput>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  creditScoreRange?: InputMaybe<Scalars['String']['input']>;
  homebuyingStage?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  type: MortgageLeadType;
  whyMesa?: InputMaybe<Scalars['String']['input']>;
  whyRefinance?: InputMaybe<Scalars['String']['input']>;
};

export type AddMortgageLeadResultModel = AddMortgageLeadErrorModel | MortgageLeadModel;

export type AddNotificationDeviceInput = {
  devicePushToken: Scalars['String']['input'];
  expoPushToken: Scalars['String']['input'];
  model: Scalars['String']['input'];
  os: Scalars['String']['input'];
  year: Scalars['String']['input'];
};

export type AddNotificationDeviceResponse = MesaGenericOk | MesaUserError;

export type Address = {
  __typename?: 'Address';
  countryCodeAlpha3?: Maybe<Scalars['String']['output']>;
  extendedAddress?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementsCategory = {
  __typename?: 'AnnouncementsCategory';
  milestones: CategorySettingsTypes;
  new_app_features: CategorySettingsTypes;
};

export type ApplePayPushProvisioningRequestDto = {
  certificates: Array<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  nonceSignature: Scalars['String']['input'];
  paymentCardId: Scalars['String']['input'];
};

export type ApplePayPushProvisioningResponseDto = {
  __typename?: 'ApplePayPushProvisioningResponseDto';
  activationData: Scalars['String']['output'];
  encryptedPassData: Scalars['String']['output'];
  ephemeralPublicKey: Scalars['String']['output'];
};

export enum ApplicationSubmissionScreen {
  Denied = 'DENIED',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  FrozenCredit = 'FROZEN_CREDIT',
  Issued = 'ISSUED',
  ManualReviewGeneric = 'MANUAL_REVIEW_GENERIC',
  NotFound = 'NOT_FOUND',
  Processing = 'PROCESSING',
  Submitting = 'SUBMITTING'
}

export type ApplyForCreditCardProductRequestDto = {
  consentTimestamp: Scalars['DateTime']['input'];
  dateOfBirth: Scalars['String']['input'];
  income: Scalars['Float']['input'];
  monthlyHousingPayment?: InputMaybe<Scalars['Float']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  ssn: Scalars['String']['input'];
};

export type ApplyForCreditCardProductResponseDto = {
  __typename?: 'ApplyForCreditCardProductResponseDto';
  /** @deprecated Use `result` instead */
  message: Scalars['String']['output'];
  result: CreateCardApplicationResult;
  /** @deprecated Use `result` instead */
  status: Scalars['String']['output'];
};

export type AuthTokenResponseDto = {
  __typename?: 'AuthTokenResponseDTO';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  refreshToken: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type AvailableSurveys = {
  __typename?: 'AvailableSurveys';
  items: Array<Survey>;
};

export type BaseAuthTokenResponseDto = {
  __typename?: 'BaseAuthTokenResponseDto';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  tokenType: Scalars['String']['output'];
};

export type Benefit = {
  __typename?: 'Benefit';
  createdAt: Scalars['DateTime']['output'];
  creditPerRefresh?: Maybe<Scalars['Float']['output']>;
  creditRedemption?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  partnerName: Scalars['String']['output'];
  refreshes?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BenefitEnrollment = {
  __typename?: 'BenefitEnrollment';
  auth0UserId: Scalars['String']['output'];
  benefitId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isEnrolled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CalculatedTransferAmountType {
  MinimumPayment = 'MinimumPayment',
  OutstandingBalance = 'OutstandingBalance',
  OutstandingStatementBalance = 'OutstandingStatementBalance'
}

export type CancelScheduledTransferResult = MesaGenericOk | MesaUserError;

export type CardActivityCardPayment = {
  __typename?: 'CardActivityCardPayment';
  achTransferId: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  sourceCreatedAt: Scalars['String']['output'];
  transferStatus: TransferStatus;
};

export type CardActivityFeedCursorInput = {
  achTransferId?: InputMaybe<Scalars['String']['input']>;
  statementCreditId?: InputMaybe<Scalars['String']['input']>;
  transactionEventId?: InputMaybe<Scalars['String']['input']>;
};

export type CardActivityFeedResponse = {
  __typename?: 'CardActivityFeedResponse';
  page: Array<CardActivityResponse>;
};

export type CardActivityFeedWhereInput = {
  NOT?: InputMaybe<CardActivityFeedWhereInput>;
  OR?: InputMaybe<Array<CardActivityFeedWhereInput>>;
  achTransferId?: InputMaybe<StringNullableFilterInput>;
  cardPayment?: InputMaybe<CardPaymentWhereInput>;
  financialEventId?: InputMaybe<StringNullableFilterInput>;
  statementCredit?: InputMaybe<StatementCreditWhereInput>;
  statementCreditId?: InputMaybe<StringNullableFilterInput>;
  transactionEventId?: InputMaybe<StringNullableFilterInput>;
  transactionEventType?: InputMaybe<EnumTransactionEventTypeNullableFilterInput>;
};

export type CardActivityFinancialEvent = {
  __typename?: 'CardActivityFinancialEvent';
  amount: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  financialEventId: Scalars['String']['output'];
  financialEventType: FinancialEventType;
  sourceCreatedAt: Scalars['String']['output'];
};

export type CardActivityOrderByWithRelationInput = {
  sourceCreatedAt?: InputMaybe<SortOrder>;
};

export type CardActivityResponse = CardActivityCardPayment | CardActivityFinancialEvent | CardActivityStatementCredit | CardActivityTransactionEvent;

export type CardActivityStatementCredit = {
  __typename?: 'CardActivityStatementCredit';
  amount: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  highnoteFinancialAccountTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
  name?: Maybe<Scalars['String']['output']>;
  sourceCreatedAt: Scalars['String']['output'];
  statementCreditId: Scalars['String']['output'];
  type: StatementCreditType;
};

export type CardActivityTransactionEvent = {
  __typename?: 'CardActivityTransactionEvent';
  merchantDetails?: Maybe<MerchantDetailsResponse>;
  pointsEarn?: Maybe<Array<TransactionEventPointsEarn>>;
  renderedAmount: RenderedAmountResponse;
  sourceCreatedAt: Scalars['String']['output'];
  transactionEventId: Scalars['String']['output'];
  transactionProcessingType: CardTransactionProcessingType;
  type: TransactionEventType;
};

export type CardApplicationAlreadyExists = {
  __typename?: 'CardApplicationAlreadyExists';
  accountHolderApplicationStatusCode?: Maybe<AccountHolderApplicationStatusCode>;
};

export type CardCategory = {
  __typename?: 'CardCategory';
  approved_transactions: CategorySettingsTypes;
  declined_transactions: CategorySettingsTypes;
  payment_failures: CategorySettingsTypes;
  payment_received: CategorySettingsTypes;
  pending_transactions: CategorySettingsTypes;
};

export type CardOrderInformation = {
  __typename?: 'CardOrderInformation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CardPaymentWhereInput = {
  status?: InputMaybe<EnumTransferStatusFilter>;
};

export type CardPurchasePointsLedgerItem = PointsLedgerItem & {
  __typename?: 'CardPurchasePointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  merchantName: Scalars['String']['output'];
  points: PointsLedgerAmount;
  pointsMultiplier: Scalars['Float']['output'];
  transactionAmount: PointsLedgerAmount;
};

export type CardReturnPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'CardReturnPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  merchantName: Scalars['String']['output'];
  points: PointsLedgerAmount;
  pointsMultiplier: Scalars['Float']['output'];
  transactionAmount: PointsLedgerAmount;
};

export enum CardTransactionProcessingType {
  AccountVerification = 'AccountVerification',
  AdjustmentCredit = 'AdjustmentCredit',
  AdjustmentDebit = 'AdjustmentDebit',
  AtmMiniStatement = 'AtmMiniStatement',
  AvailableFundsInquiry = 'AvailableFundsInquiry',
  BalanceInquiry = 'BalanceInquiry',
  CardholderAccountsTransfer = 'CardholderAccountsTransfer',
  Cash = 'Cash',
  CashDisbursement = 'CashDisbursement',
  Deposits = 'Deposits',
  EligibilityInquiry = 'EligibilityInquiry',
  FeeCollectionDebit = 'FeeCollectionDebit',
  FundsDisbursementCredit = 'FundsDisbursementCredit',
  FundsWithdrawalForElectronicPurse = 'FundsWithdrawalForElectronicPurse',
  GoodsAndServices = 'GoodsAndServices',
  GoodsAndServicesWithCashDisbursement = 'GoodsAndServicesWithCashDisbursement',
  LoadOfPrepaidOrStoredValueCard = 'LoadOfPrepaidOrStoredValueCard',
  NonCashFinancialForFunding = 'NonCashFinancialForFunding',
  NotificationToBank = 'NotificationToBank',
  OriginalCredit = 'OriginalCredit',
  PaymentCredit = 'PaymentCredit',
  PaymentDebit = 'PaymentDebit',
  PaymentEnclosed = 'PaymentEnclosed',
  PaymentFromThirdParty = 'PaymentFromThirdParty',
  PaymentToAnotherParty = 'PaymentToAnotherParty',
  PaymentTransaction = 'PaymentTransaction',
  PinChange = 'PinChange',
  PinUnblock = 'PinUnblock',
  QuasiCashAndScrip = 'QuasiCashAndScrip',
  Returns = 'Returns'
}

export type CashForMortgageRedemptionMetricsResponse = {
  __typename?: 'CashForMortgageRedemptionMetricsResponse';
  isEligible: Scalars['Boolean']['output'];
  remainingMonthlyCents: Scalars['Float']['output'];
  totalAmountCents: Scalars['Float']['output'];
  totalPointsRedeemed: Scalars['Float']['output'];
};

export type CategorySettingsTypes = {
  __typename?: 'CategorySettingsTypes';
  email: Scalars['Boolean']['output'];
  push_notification: Scalars['Boolean']['output'];
};

export type CheckPhoneNumberIsAvailableResponse = {
  __typename?: 'CheckPhoneNumberIsAvailableResponse';
  phoneNumberIsAvailable: Scalars['Boolean']['output'];
};

export type CloseLinkedExternalBankAccountResult = MesaGenericOk | MesaUserError;

export type CreateCardApplicationResult = CardApplicationAlreadyExists | MesaGenericOk | MesaUserError | SynchronousApplicationSubmissionResult;

export type CreateLinkTokenResponse = {
  __typename?: 'CreateLinkTokenResponse';
  expiration: Scalars['String']['output'];
  linkToken: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
};

export type CreateMesaHomeDocumentUploadLinkModel = {
  __typename?: 'CreateMesaHomeDocumentUploadLinkModel';
  url: Scalars['String']['output'];
};

export type CreateMesaHomeMonthlyAward = {
  __typename?: 'CreateMesaHomeMonthlyAward';
  awardAmountInPoints: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  source: MesaHomeMonthlyAwardSource;
};

export type CreateMortgageAddressRequestDto = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  plaidAccountId?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type CreateOneTimePaymentResult = MesaGenericOk | MesaUserError;

export type CreateRecurringPaymentResult = MesaGenericOk | MesaUserError;

export type CreditCardPingResponse = {
  __typename?: 'CreditCardPingResponse';
  ping: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
};

export type CreditCardResponse = {
  __typename?: 'CreditCardResponse';
  lastFour?: Maybe<Scalars['String']['output']>;
};

export type EnrollInBenefitInput = {
  benefitName: Scalars['String']['input'];
};

export type EnrollInBenefitResponse = MesaGenericOk | MesaUserError;

export type EnrollInstacartBenefitResponse = {
  __typename?: 'EnrollInstacartBenefitResponse';
  url: Scalars['String']['output'];
};

export type EnrollReferralBonusOfferResponse = {
  __typename?: 'EnrollReferralBonusOfferResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EnumInterFinancialAccountTransferStatusNullableFilter = {
  in?: InputMaybe<Array<InterFinancialAccountTransferStatus>>;
  notIn?: InputMaybe<Array<InterFinancialAccountTransferStatus>>;
};

export type EnumTransactionEventTypeNullableFilterInput = {
  equals?: InputMaybe<TransactionEventType>;
  not?: InputMaybe<TransactionEventType>;
};

export type EnumTransferStatusFilter = {
  in?: InputMaybe<Array<TransferStatus>>;
  notIn?: InputMaybe<Array<TransferStatus>>;
};

export type ExternalRedemptionPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'ExternalRedemptionPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  orderDescription: Scalars['String']['output'];
  points: PointsLedgerAmount;
};

export type ExternalRedemptionRefundPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'ExternalRedemptionRefundPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  orderDescription: Scalars['String']['output'];
  points: PointsLedgerAmount;
};

export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  accountHodlerCreditLimit: Scalars['Float']['output'];
  accountStatus: Scalars['String']['output'];
  availableCredit: Scalars['Float']['output'];
  creditOutstanding: Scalars['Float']['output'];
  currentAmountDue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  outstandingBalancePayable: Scalars['Float']['output'];
  paymentCardAPR?: Maybe<Scalars['Float']['output']>;
  paymentCardCreditLine?: Maybe<Scalars['Float']['output']>;
  /** local iso date string for next closing date */
  paymentCardNextClosingDate?: Maybe<Scalars['String']['output']>;
  statementBalance?: Maybe<Scalars['String']['output']>;
  statementMinimumPayment?: Maybe<Scalars['String']['output']>;
  statementPaymentDueOn?: Maybe<Scalars['String']['output']>;
  statementPeriodEnd?: Maybe<Scalars['String']['output']>;
  statementPeriodStart?: Maybe<Scalars['String']['output']>;
};

/** Possible types for a financial event */
export enum FinancialEventType {
  CheckPaymentEvent = 'CheckPaymentEvent',
  CreditCardTransferEvent = 'CreditCardTransferEvent',
  FeeTransferEvent = 'FeeTransferEvent',
  InterFinancialAccountTransfer = 'InterFinancialAccountTransfer',
  ManualAdjustmentEvent = 'ManualAdjustmentEvent',
  Transfer = 'Transfer'
}

export type FindCardOrderResponse = {
  __typename?: 'FindCardOrderResponse';
  node?: Maybe<CardOrderInformation>;
};

export type FindPaymentCardResponse = {
  __typename?: 'FindPaymentCardResponse';
  node?: Maybe<Node>;
};

export type FindSchedulePaymentResponse = {
  __typename?: 'FindSchedulePaymentResponse';
  nextScheduledTransferDate?: Maybe<Scalars['String']['output']>;
  schedulePaymentId?: Maybe<Scalars['String']['output']>;
  scheduledTransferDate?: Maybe<Scalars['String']['output']>;
  transferAmountStrategy?: Maybe<CalculatedTransferAmountType>;
  transferSourceAccount?: Maybe<Account>;
};

export type GenerateStatementPdfLinkRequestDto = {
  statementId: Scalars['String']['input'];
};

export type GenerateStatementPdfLinkResponseDto = {
  __typename?: 'GenerateStatementPdfLinkResponseDto';
  url: Scalars['String']['output'];
};

export type GeoLookupResultModel = GeolocationInferenceFailedModel | InferredGeolocationModel;

export type GeolocationInferenceFailedModel = {
  __typename?: 'GeolocationInferenceFailedModel';
  errorMessage: Scalars['String']['output'];
};

export type GetBenefitStatementCreditsByBenefitIdResponse = {
  __typename?: 'GetBenefitStatementCreditsByBenefitIdResponse';
  amount: Scalars['Float']['output'];
};

export type GetBenefitsResponse = {
  __typename?: 'GetBenefitsResponse';
  benefits: Array<Benefit>;
};

export type GetLinkedExternalAccountsResponse = {
  __typename?: 'GetLinkedExternalAccountsResponse';
  accounts: Array<Account>;
};

export type GetMemberBenefitEnrollmentsResponse = {
  __typename?: 'GetMemberBenefitEnrollmentsResponse';
  benefitEnrollments?: Maybe<Array<BenefitEnrollment>>;
};

export type GetMortgageAddressesResponseDto = {
  __typename?: 'GetMortgageAddressesResponseDto';
  addresses: Array<MortgageAddress>;
};

export type GetMyLowesRewardsStatusResponse = {
  __typename?: 'GetMyLowesRewardsStatusResponse';
  enrolled: Scalars['Boolean']['output'];
  enrollmentDate: Scalars['String']['output'];
  exp: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  reasonCode: Scalars['String']['output'];
};

export type GetNewestMortgageLeadRequestDto = {
  loanPurpose: Scalars['String']['input'];
};

export type GetNewestMortgageLeadResponse = {
  __typename?: 'GetNewestMortgageLeadResponse';
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GetNotificationSettingsResponse = {
  __typename?: 'GetNotificationSettingsResponse';
  settings: NotificationSettings;
};

export type GetReferralBonusOfferEligibilityResponse = {
  __typename?: 'GetReferralBonusOfferEligibilityResponse';
  isEligible: Scalars['Boolean']['output'];
};

export type GetUserInfoResponse = {
  __typename?: 'GetUserInfoResponse';
  cardInformation?: Maybe<CreditCardResponse>;
  /** @deprecated Clients probably don't need this field */
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated in the backend, this value should be available from the request context. in the frontend, you shouldn't be using this value since the user's id is implied from being logged in */
  id: Scalars['String']['output'];
  /** @deprecated Clients probably don't need this field */
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is a legacy API from when we were storing user info in Auth0. The only field it contains (`userTrackingFlag`) shouldn't be used (see {@link UserInfoResponseInterface}) */
  metadata?: Maybe<UserMetadataResponse>;
  /** @deprecated Use `firstName` and `lastName` instead */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated We don't use this field */
  nickname?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated The binarity of `phoneNumber` implies its verification (we only save the `phoneNumber` into the database once it's been verified) */
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated We don't use this field */
  picture?: Maybe<Scalars['String']['output']>;
  redeemedCardInviteCode?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  sourcePartnerName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** @deprecated Clients probably don't need this field */
  updatedAt: Scalars['String']['output'];
};

export type GetUserNotificationsResponse = {
  __typename?: 'GetUserNotificationsResponse';
  notifications: Array<Notifications>;
};

export type GetWaitlistStatusResponseDto = {
  __typename?: 'GetWaitlistStatusResponseDto';
  isWaitlisted: Scalars['Boolean']['output'];
};

export type GoodwillPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'GoodwillPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  points: PointsLedgerAmount;
};

export type HighnoteClientToken = {
  __typename?: 'HighnoteClientToken';
  clientToken: Scalars['String']['output'];
};

export type HighnoteDocumentUploadClientToken = {
  __typename?: 'HighnoteDocumentUploadClientToken';
  /** @deprecated use `result` instead */
  clientToken: Scalars['String']['output'];
  result: HighnoteDocumentUploadClientTokenResult;
  /** @deprecated use `result` instead */
  sessionId: Scalars['String']['output'];
};

export type HighnoteDocumentUploadClientTokenResult = HighnoteDocumentUploadClientTokenSuccess | HighnoteDocumentUploadClientTokenUnavailable | MesaUserError;

export type HighnoteDocumentUploadClientTokenSuccess = {
  __typename?: 'HighnoteDocumentUploadClientTokenSuccess';
  clientTokenValue: Scalars['String']['output'];
  documentUploadSessionId: Scalars['String']['output'];
};

export type HighnoteDocumentUploadClientTokenUnavailable = {
  __typename?: 'HighnoteDocumentUploadClientTokenUnavailable';
  message: Scalars['String']['output'];
};

export type HighnoteExternalAccountResponse = {
  __typename?: 'HighnoteExternalAccountResponse';
  accountName?: Maybe<Scalars['String']['output']>;
  accountSubtype?: Maybe<Scalars['String']['output']>;
  bankAccountLast4?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  highnoteExternalAccountId: Scalars['ID']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
};

export type IGetAccountHolderCardProductApplicationObjectType = {
  __typename?: 'IGetAccountHolderCardProductApplicationObjectType';
  apr: Scalars['Float']['output'];
  creditLine: Scalars['Float']['output'];
};

export type IGetCardProductApplicationStatusObjectType = {
  __typename?: 'IGetCardProductApplicationStatusObjectType';
  paymentCardId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type IncomingScheduledTransferResponse = OneTimeAchTransferResponse | RecurringAchTransferResponse;

export type IncomingScheduledTransfersResponse = {
  __typename?: 'IncomingScheduledTransfersResponse';
  page: Array<IncomingScheduledTransferResponse>;
};

export type InferredGeolocationModel = {
  __typename?: 'InferredGeolocationModel';
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type InstitutionModel = {
  __typename?: 'InstitutionModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Possible types for a financial account transfer */
export enum InterFinancialAccountTransferStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export enum Iso3166Alpha3Country {
  Abw = 'Abw',
  Afg = 'Afg',
  Ago = 'Ago',
  Aia = 'Aia',
  Ala = 'Ala',
  Alb = 'Alb',
  And = 'And',
  Are = 'Are',
  Arg = 'Arg',
  Arm = 'Arm',
  Asm = 'Asm',
  Ata = 'Ata',
  Atf = 'Atf',
  Atg = 'Atg',
  Aus = 'Aus',
  Aut = 'Aut',
  Aze = 'Aze',
  Bdi = 'Bdi',
  Bel = 'Bel',
  Ben = 'Ben',
  Bes = 'Bes',
  Bfa = 'Bfa',
  Bgd = 'Bgd',
  Bgr = 'Bgr',
  Bhr = 'Bhr',
  Bhs = 'Bhs',
  Bih = 'Bih',
  Blm = 'Blm',
  Blr = 'Blr',
  Blz = 'Blz',
  Bmu = 'Bmu',
  Bol = 'Bol',
  Bra = 'Bra',
  Brb = 'Brb',
  Brn = 'Brn',
  Btn = 'Btn',
  Bvt = 'Bvt',
  Bwa = 'Bwa',
  Caf = 'Caf',
  Can = 'Can',
  Cck = 'Cck',
  Che = 'Che',
  Chl = 'Chl',
  Chn = 'Chn',
  Civ = 'Civ',
  Cmr = 'Cmr',
  Cod = 'Cod',
  Cog = 'Cog',
  Cok = 'Cok',
  Col = 'Col',
  Com = 'Com',
  Cpv = 'Cpv',
  Cri = 'Cri',
  Cub = 'Cub',
  Cuw = 'Cuw',
  Cxr = 'Cxr',
  Cym = 'Cym',
  Cyp = 'Cyp',
  Cze = 'Cze',
  Deu = 'Deu',
  Dji = 'Dji',
  Dma = 'Dma',
  Dnk = 'Dnk',
  Dom = 'Dom',
  Dza = 'Dza',
  Ecu = 'Ecu',
  Egy = 'Egy',
  Eri = 'Eri',
  Esh = 'Esh',
  Esp = 'Esp',
  Est = 'Est',
  Eth = 'Eth',
  Fin = 'Fin',
  Fji = 'Fji',
  Flk = 'Flk',
  Fra = 'Fra',
  Fro = 'Fro',
  Fsm = 'Fsm',
  Gab = 'Gab',
  Gbr = 'Gbr',
  Geo = 'Geo',
  Ggy = 'Ggy',
  Gha = 'Gha',
  Gib = 'Gib',
  Gin = 'Gin',
  Glp = 'Glp',
  Gmb = 'Gmb',
  Gnb = 'Gnb',
  Gnq = 'Gnq',
  Grc = 'Grc',
  Grd = 'Grd',
  Grl = 'Grl',
  Gtm = 'Gtm',
  Guf = 'Guf',
  Gum = 'Gum',
  Guy = 'Guy',
  Hkg = 'Hkg',
  Hmd = 'Hmd',
  Hnd = 'Hnd',
  Hrv = 'Hrv',
  Hti = 'Hti',
  Hun = 'Hun',
  Idn = 'Idn',
  Imn = 'Imn',
  Ind = 'Ind',
  Iot = 'Iot',
  Irl = 'Irl',
  Irn = 'Irn',
  Irq = 'Irq',
  Isl = 'Isl',
  Isr = 'Isr',
  Ita = 'Ita',
  Jam = 'Jam',
  Jey = 'Jey',
  Jor = 'Jor',
  Jpn = 'Jpn',
  Kaz = 'Kaz',
  Ken = 'Ken',
  Kgz = 'Kgz',
  Khm = 'Khm',
  Kir = 'Kir',
  Kna = 'Kna',
  Kor = 'Kor',
  Kwt = 'Kwt',
  Lao = 'Lao',
  Lbn = 'Lbn',
  Lbr = 'Lbr',
  Lby = 'Lby',
  Lca = 'Lca',
  Lie = 'Lie',
  Lka = 'Lka',
  Lso = 'Lso',
  Ltu = 'Ltu',
  Lux = 'Lux',
  Lva = 'Lva',
  Mac = 'Mac',
  Maf = 'Maf',
  Mar = 'Mar',
  Mco = 'Mco',
  Mda = 'Mda',
  Mdg = 'Mdg',
  Mdv = 'Mdv',
  Mex = 'Mex',
  Mhl = 'Mhl',
  Mkd = 'Mkd',
  Mli = 'Mli',
  Mlt = 'Mlt',
  Mmr = 'Mmr',
  Mne = 'Mne',
  Mng = 'Mng',
  Mnp = 'Mnp',
  Moz = 'Moz',
  Mrt = 'Mrt',
  Msr = 'Msr',
  Mtq = 'Mtq',
  Mus = 'Mus',
  Mwi = 'Mwi',
  Mys = 'Mys',
  Myt = 'Myt',
  Nam = 'Nam',
  Ncl = 'Ncl',
  Ner = 'Ner',
  Nfk = 'Nfk',
  Nga = 'Nga',
  Nic = 'Nic',
  Niu = 'Niu',
  Nld = 'Nld',
  Nor = 'Nor',
  Npl = 'Npl',
  Nru = 'Nru',
  Nzl = 'Nzl',
  Omn = 'Omn',
  Pak = 'Pak',
  Pan = 'Pan',
  Pcn = 'Pcn',
  Per = 'Per',
  Phl = 'Phl',
  Plw = 'Plw',
  Png = 'Png',
  Pol = 'Pol',
  Pri = 'Pri',
  Prk = 'Prk',
  Prt = 'Prt',
  Pry = 'Pry',
  Pse = 'Pse',
  Pyf = 'Pyf',
  Qat = 'Qat',
  Qzz = 'Qzz',
  Reu = 'Reu',
  Rou = 'Rou',
  Rus = 'Rus',
  Rwa = 'Rwa',
  Sau = 'Sau',
  Sdn = 'Sdn',
  Sen = 'Sen',
  Sgp = 'Sgp',
  Sgs = 'Sgs',
  Shn = 'Shn',
  Sjm = 'Sjm',
  Slb = 'Slb',
  Sle = 'Sle',
  Slv = 'Slv',
  Smr = 'Smr',
  Som = 'Som',
  Spm = 'Spm',
  Srb = 'Srb',
  Ssd = 'Ssd',
  Stp = 'Stp',
  Sur = 'Sur',
  Svk = 'Svk',
  Svn = 'Svn',
  Swe = 'Swe',
  Swz = 'Swz',
  Sxm = 'Sxm',
  Syc = 'Syc',
  Syr = 'Syr',
  Tca = 'Tca',
  Tcd = 'Tcd',
  Tgo = 'Tgo',
  Tha = 'Tha',
  Tjk = 'Tjk',
  Tkl = 'Tkl',
  Tkm = 'Tkm',
  Tls = 'Tls',
  Ton = 'Ton',
  Tto = 'Tto',
  Tun = 'Tun',
  Tur = 'Tur',
  Tuv = 'Tuv',
  Twn = 'Twn',
  Tza = 'Tza',
  Uga = 'Uga',
  Ukr = 'Ukr',
  Umi = 'Umi',
  Ury = 'Ury',
  Usa = 'Usa',
  Uzb = 'Uzb',
  Vat = 'Vat',
  Vct = 'Vct',
  Ven = 'Ven',
  Vgb = 'Vgb',
  Vir = 'Vir',
  Vnm = 'Vnm',
  Vut = 'Vut',
  Wlf = 'Wlf',
  Wsm = 'Wsm',
  Yem = 'Yem',
  Zaf = 'Zaf',
  Zmb = 'Zmb',
  Zwe = 'Zwe'
}

export type JoinWaitlistResponseDto = {
  __typename?: 'JoinWaitlistResponseDto';
  message: Scalars['String']['output'];
  status: JoinWaitlistResponseStatus;
};

export enum JoinWaitlistResponseStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type LinkAccount = {
  id: Scalars['String']['input'];
  institutionId?: InputMaybe<Scalars['String']['input']>;
  mask: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shouldLinkToHighnote?: InputMaybe<Scalars['Boolean']['input']>;
  subtype: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type LinkAccountInput = {
  id: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subtype: Scalars['String']['input'];
  type: Scalars['String']['input'];
  verificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type LinkInstitution = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LinkInstitutionInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LinkResultModel = {
  __typename?: 'LinkResultModel';
  /** @deprecated Mesa Home enrollment is no longer done thru Plaid and enrollment is implicit upon card creation */
  mesaHomeEnrollment?: Maybe<MesaHomeEnrollment>;
  status: LinkResultStatus;
};

export enum LinkResultStatus {
  DuplicateAccount = 'DUPLICATE_ACCOUNT',
  Error = 'ERROR',
  PendingAuthVerification = 'PENDING_AUTH_VERIFICATION',
  Success = 'SUCCESS'
}

export type LinkSuccessInput = {
  accounts: Array<LinkAccount>;
  institution?: InputMaybe<LinkInstitution>;
  publicToken: Scalars['String']['input'];
  shouldImportTransactions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkSuccessInputDto = {
  metadata: LinkSuccessMetadataInput;
  publicToken: Scalars['String']['input'];
};

export type LinkSuccessMetadataInput = {
  accounts: Array<LinkAccountInput>;
  institution?: InputMaybe<LinkInstitutionInput>;
  linkSessionId: Scalars['String']['input'];
  metadataJson?: InputMaybe<Scalars['String']['input']>;
};

export type LinkedAccountModel = {
  __typename?: 'LinkedAccountModel';
  availableProducts: Array<Products>;
  billedProducts: Array<Products>;
  consentedProducts: Array<Products>;
  id: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  isAuthActive: Scalars['Boolean']['output'];
  isTransactionsActive: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  mask: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<Products>;
  status: PlaidItemStatus;
  subtype: Scalars['String']['output'];
  type: Scalars['String']['output'];
  verificationStatus: AccountVerificationStatus;
};

export type LinkedItemModel = {
  __typename?: 'LinkedItemModel';
  accounts: Array<AccountModel>;
  cardPaymentsProductEnrollment: ProductEnrollmentModel;
  id: Scalars['String']['output'];
  institution: InstitutionModel;
  /** @deprecated Use `mesaHomeEnrollment` instead */
  mesaHomeProductEnrollment: ProductEnrollmentModel;
  status: PlaidItemStatus;
};

export type LoyaltyTierEventPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'LoyaltyTierEventPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  eventDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
  reason: Scalars['String']['output'];
};

export type ManualTransferAmountResponse = {
  __typename?: 'ManualTransferAmountResponse';
  renderedAmount: RenderedAmountResponse;
};

export type MarketingCategory = {
  __typename?: 'MarketingCategory';
  mesa_mortgage: CategorySettingsTypes;
  new_benefits: CategorySettingsTypes;
  new_rewards: CategorySettingsTypes;
};

export enum MerchantCategory {
  A1RentACar = 'A1RentACar',
  AcHotels = 'AcHotels',
  AcRefrigerationRepair = 'AcRefrigerationRepair',
  AccentRentACar = 'AccentRentACar',
  AccountingBookkeepingServices = 'AccountingBookkeepingServices',
  ActionAutoRental = 'ActionAutoRental',
  AdamsMark = 'AdamsMark',
  AdriaAir = 'AdriaAir',
  AdvantageRentACar = 'AdvantageRentACar',
  AdvertisingServices = 'AdvertisingServices',
  Aeorflot = 'Aeorflot',
  AerLingus = 'AerLingus',
  AeroCoachAviation = 'AeroCoachAviation',
  AeroContinente = 'AeroContinente',
  AeroNicaraguensis = 'AeroNicaraguensis',
  AeroPeru = 'AeroPeru',
  AeroVirginIslands = 'AeroVirginIslands',
  AerolineasArgentinas = 'AerolineasArgentinas',
  Aeromexico = 'Aeromexico',
  AffiliatedAutoRental = 'AffiliatedAutoRental',
  Affinia = 'Affinia',
  AgencyRentACar = 'AgencyRentACar',
  AgriculturalCooperative = 'AgriculturalCooperative',
  AirAfrique = 'AirAfrique',
  AirAlgerie = 'AirAlgerie',
  AirArabia = 'AirArabia',
  AirAstana = 'AirAstana',
  AirBaltic = 'AirBaltic',
  AirBerlin = 'AirBerlin',
  AirBritishColumbia = 'AirBritishColumbia',
  AirCanada = 'AirCanada',
  AirChina = 'AirChina',
  AirDjibouti = 'AirDjibouti',
  AirFrance = 'AirFrance',
  AirIndia = 'AirIndia',
  AirJamaica = 'AirJamaica',
  AirLanka = 'AirLanka',
  AirLittoral = 'AirLittoral',
  AirMalta = 'AirMalta',
  AirMaroc = 'AirMaroc',
  AirMauritius = 'AirMauritius',
  AirNewZealand = 'AirNewZealand',
  AirPanama = 'AirPanama',
  AirSeychelles = 'AirSeychelles',
  AirZaire = 'AirZaire',
  AirZimbabweCorp = 'AirZimbabweCorp',
  Airinter = 'Airinter',
  AirlinesAirCarriers = 'AirlinesAirCarriers',
  AirportsFlyingFields = 'AirportsFlyingFields',
  AirtranAirways = 'AirtranAirways',
  Airways = 'Airways',
  AjaxRentACar = 'AjaxRentACar',
  AlaMoanaHotel = 'AlaMoanaHotel',
  AladdinResortAndCasino = 'AladdinResortAndCasino',
  AlamoRentACar = 'AlamoRentACar',
  AlaskaAir = 'AlaskaAir',
  Alitalia = 'Alitalia',
  Allstate = 'Allstate',
  AlmAirline = 'AlmAirline',
  Aloft = 'Aloft',
  AlohaAirlines = 'AlohaAirlines',
  AltraAutoRental = 'AltraAutoRental',
  AmbulanceServices = 'AmbulanceServices',
  AmeliaIslandPlantation = 'AmeliaIslandPlantation',
  AmericaWest = 'AmericaWest',
  AmericanAirlines = 'AmericanAirlines',
  AmericanInternational = 'AmericanInternational',
  AmericanaHotelsCorporation = 'AmericanaHotelsCorporation',
  AmericasBestValueInn = 'AmericasBestValueInn',
  Americinn = 'Americinn',
  Amerisuites = 'Amerisuites',
  AmfacHotels = 'AmfacHotels',
  AmusementParksCarnivals = 'AmusementParksCarnivals',
  AnaAir = 'AnaAir',
  AnaHotels = 'AnaHotels',
  AnsaInternational = 'AnsaInternational',
  AnsettAirlines = 'AnsettAirlines',
  AntiqueReproductions = 'AntiqueReproductions',
  AntiqueShops = 'AntiqueShops',
  Aquariums = 'Aquariums',
  ArabellaHotels = 'ArabellaHotels',
  Arcade = 'Arcade',
  ArchitecturalSurveyingServices = 'ArchitecturalSurveyingServices',
  Arctia = 'Arctia',
  Aria = 'Aria',
  ArizonaBiltmore = 'ArizonaBiltmore',
  ArtDealersAndGalleries = 'ArtDealersAndGalleries',
  ArtistsSupplyAndCraftShops = 'ArtistsSupplyAndCraftShops',
  AscAirline = 'AscAirline',
  AsianaAirlines = 'AsianaAirlines',
  AtaAir = 'AtaAir',
  AtlanticCityHilton = 'AtlanticCityHilton',
  AubergeDesGoverneurs = 'AubergeDesGoverneurs',
  AustrianAir = 'AustrianAir',
  AustrianAirService = 'AustrianAirService',
  AutoAndHomeSupplyStores = 'AutoAndHomeSupplyStores',
  AutoBodyRepairShops = 'AutoBodyRepairShops',
  AutoHostRentalCars = 'AutoHostRentalCars',
  AutoPaintShops = 'AutoPaintShops',
  AutoServiceShops = 'AutoServiceShops',
  Autograph = 'Autograph',
  Autohansa = 'Autohansa',
  Automate = 'Automate',
  AutomatedCashDisburse = 'AutomatedCashDisburse',
  AutomatedFuelDispensers = 'AutomatedFuelDispensers',
  AutomobileAssociations = 'AutomobileAssociations',
  AutomotivePartsAndAccessoriesStores = 'AutomotivePartsAndAccessoriesStores',
  AutomotiveTireStores = 'AutomotiveTireStores',
  Avcar = 'Avcar',
  AvensaAir = 'AvensaAir',
  AviacoAir = 'AviacoAir',
  Avianca = 'Avianca',
  AviatecaAir = 'AviatecaAir',
  AvisRentACar = 'AvisRentACar',
  AvonRentACar = 'AvonRentACar',
  AzulBrazilianAirlines = 'AzulBrazilianAirlines',
  BahamasAir = 'BahamasAir',
  BailAndBondPayments = 'BailAndBondPayments',
  Bakeries = 'Bakeries',
  BalkanAir = 'BalkanAir',
  BallysHotelAndCasino = 'BallysHotelAndCasino',
  BandsOrchestras = 'BandsOrchestras',
  BarHarborAirlines = 'BarHarborAirlines',
  BarberAndBeautyShops = 'BarberAndBeautyShops',
  BartonCreekResort = 'BartonCreekResort',
  BeauRivageHotelAndCasino = 'BeauRivageHotelAndCasino',
  Bellagio = 'Bellagio',
  BemidjiAir = 'BemidjiAir',
  BestWestern = 'BestWestern',
  BettingCasinoGambling = 'BettingCasinoGambling',
  BeverlyHillsHotel = 'BeverlyHillsHotel',
  BicycleShops = 'BicycleShops',
  BilliardPoolEstablishments = 'BilliardPoolEstablishments',
  BiltmoreHotelAndSuites = 'BiltmoreHotelAndSuites',
  BinionsHorseshoeClub = 'BinionsHorseshoeClub',
  BlueprintingAndPhotocopyingServices = 'BlueprintingAndPhotocopyingServices',
  BoatDealers = 'BoatDealers',
  BoatRentalsAndLeases = 'BoatRentalsAndLeases',
  BocaRatonResort = 'BocaRatonResort',
  BookStores = 'BookStores',
  BooksPeriodicalsAndNewspapers = 'BooksPeriodicalsAndNewspapers',
  BowlingAlleys = 'BowlingAlleys',
  Braathens = 'Braathens',
  BradburySuites = 'BradburySuites',
  BreakersResort = 'BreakersResort',
  BreezbayHotelGroup = 'BreezbayHotelGroup',
  BritishAirways = 'BritishAirways',
  BritishMidlandAir = 'BritishMidlandAir',
  BroadmoorHotel = 'BroadmoorHotel',
  BrockwayAir = 'BrockwayAir',
  BrooksRentACar = 'BrooksRentACar',
  BudgetHostInns = 'BudgetHostInns',
  BudgetRentACar = 'BudgetRentACar',
  Budgetel = 'Budgetel',
  BuffaloBillsHotelAndCasino = 'BuffaloBillsHotelAndCasino',
  Bulgari = 'Bulgari',
  BusLines = 'BusLines',
  BusinessSecretarialSchools = 'BusinessSecretarialSchools',
  BuyingShoppingServices = 'BuyingShoppingServices',
  CMonInn = 'CMonInn',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'CableSatelliteAndOtherPayTelevisionAndRadio',
  CaesarsHotelAndCasino = 'CaesarsHotelAndCasino',
  CaliforniaHotelAndCasino = 'CaliforniaHotelAndCasino',
  CameraAndPhotographicSupplyStores = 'CameraAndPhotographicSupplyStores',
  Campanile = 'Campanile',
  CanadianAir = 'CanadianAir',
  CanadianPacific = 'CanadianPacific',
  CandeoHotels = 'CandeoHotels',
  CandlewoodSuites = 'CandlewoodSuites',
  CandyNutAndConfectioneryStores = 'CandyNutAndConfectioneryStores',
  CanyonRanch = 'CanyonRanch',
  CapitolAir = 'CapitolAir',
  CarAndTruckDealersNewUsed = 'CarAndTruckDealersNewUsed',
  CarAndTruckDealersUsedOnly = 'CarAndTruckDealersUsedOnly',
  CarRental = 'CarRental',
  CarRentalAgencies = 'CarRentalAgencies',
  CarWashes = 'CarWashes',
  CarefreeResorts = 'CarefreeResorts',
  Carey = 'Carey',
  CaribbeanAirlines = 'CaribbeanAirlines',
  CaribeRoyal = 'CaribeRoyal',
  CaribeRoyalResortSuiteAndVillas = 'CaribeRoyalResortSuiteAndVillas',
  CarltonHotels = 'CarltonHotels',
  CarnivalAirlines = 'CarnivalAirlines',
  CarpentryServices = 'CarpentryServices',
  CarpetUpholsteryCleaning = 'CarpetUpholsteryCleaning',
  Caterers = 'Caterers',
  CathayPacific = 'CathayPacific',
  CaymanAirways = 'CaymanAirways',
  CebuPacificAirlines = 'CebuPacificAirlines',
  ChampagneProducers = 'ChampagneProducers',
  CharitableAndSocialServiceOrganizationsFundraising = 'CharitableAndSocialServiceOrganizationsFundraising',
  ChateauElanWineryAndResort = 'ChateauElanWineryAndResort',
  ChemicalsAndAlliedProducts = 'ChemicalsAndAlliedProducts',
  ChildCareServices = 'ChildCareServices',
  ChildrensAndInfantsWearStores = 'ChildrensAndInfantsWearStores',
  ChinaAirlines = 'ChinaAirlines',
  ChinaEasternAirlines = 'ChinaEasternAirlines',
  ChinaSouthernAirlines = 'ChinaSouthernAirlines',
  ChiropodistsPodiatrists = 'ChiropodistsPodiatrists',
  Chiropractors = 'Chiropractors',
  Cigahotels = 'Cigahotels',
  CigarStoresAndStands = 'CigarStoresAndStands',
  CircusCircusHotelAndCasino = 'CircusCircusHotelAndCasino',
  Cite = 'Cite',
  CityLodgeHotels = 'CityLodgeHotels',
  CivicSocialFraternalAssociations = 'CivicSocialFraternalAssociations',
  ClaridgeCasinoHotel = 'ClaridgeCasinoHotel',
  ClarionHotel = 'ClarionHotel',
  CleaningAndMaintenance = 'CleaningAndMaintenance',
  ClimatDeFrance = 'ClimatDeFrance',
  ClothingRental = 'ClothingRental',
  ClubCorporationClubResorts = 'ClubCorporationClubResorts',
  ClubMed = 'ClubMed',
  CoastHotels = 'CoastHotels',
  CollegesUniversities = 'CollegesUniversities',
  ColoradoBelleEdgewaterResort = 'ColoradoBelleEdgewaterResort',
  Comair = 'Comair',
  ComfortHotelInternational = 'ComfortHotelInternational',
  CommandAir = 'CommandAir',
  CommercialEquipment = 'CommercialEquipment',
  CommercialFootwear = 'CommercialFootwear',
  CommercialPhotographyArtAndGraphics = 'CommercialPhotographyArtAndGraphics',
  CommuterTransportAndFerries = 'CommuterTransportAndFerries',
  CompFauAir = 'CompFauAir',
  CompriHotel = 'CompriHotel',
  ComputerNetworkServices = 'ComputerNetworkServices',
  ComputerProgramming = 'ComputerProgramming',
  ComputerRepair = 'ComputerRepair',
  ComputerSoftwareStores = 'ComputerSoftwareStores',
  ComputersPeripheralsAndSoftware = 'ComputersPeripheralsAndSoftware',
  Concession = 'Concession',
  ConcordeHotels = 'ConcordeHotels',
  ConcreteWorkServices = 'ConcreteWorkServices',
  ConradHotels = 'ConradHotels',
  Consort = 'Consort',
  ConstructionMaterials = 'ConstructionMaterials',
  ConsultingPublicRelations = 'ConsultingPublicRelations',
  ContinentalAirlines = 'ContinentalAirlines',
  CopaAir = 'CopaAir',
  CoreGlobalManagementHotelsAndResorts = 'CoreGlobalManagementHotelsAndResorts',
  CorrespondenceSchools = 'CorrespondenceSchools',
  CosmeticStores = 'CosmeticStores',
  CosmopolitanOfLasVegas = 'CosmopolitanOfLasVegas',
  CounselingServices = 'CounselingServices',
  CountryClubs = 'CountryClubs',
  CountryInnByCarlson = 'CountryInnByCarlson',
  CourierServices = 'CourierServices',
  CourtCosts = 'CourtCosts',
  CourtyardByMarriott = 'CourtyardByMarriott',
  CreditReportingAgencies = 'CreditReportingAgencies',
  CrestHotels = 'CrestHotels',
  CroatiaAir = 'CroatiaAir',
  Crossland = 'Crossland',
  CrownAir = 'CrownAir',
  CrownePlazaHotels = 'CrownePlazaHotels',
  CruiseLines = 'CruiseLines',
  CruzieroAir = 'CruzieroAir',
  CsaAirline = 'CsaAirline',
  CumberlandAirlines = 'CumberlandAirlines',
  CumulusHotels = 'CumulusHotels',
  CunardHotels = 'CunardHotels',
  CyprusAirways = 'CyprusAirways',
  DairyProductsStores = 'DairyProductsStores',
  DanAirServices = 'DanAirServices',
  DanHotels = 'DanHotels',
  DanceHallStudiosSchools = 'DanceHallStudiosSchools',
  DatingEscortServices = 'DatingEscortServices',
  DaysInnsOfAmerica = 'DaysInnsOfAmerica',
  DbaAir = 'DbaAir',
  DeVereHotels = 'DeVereHotels',
  DeltaAirlines = 'DeltaAirlines',
  DeltaHotels = 'DeltaHotels',
  DentistsOrthodontists = 'DentistsOrthodontists',
  DepartmentStores = 'DepartmentStores',
  DetectiveAgencies = 'DetectiveAgencies',
  DigitalGoodsApplications = 'DigitalGoodsApplications',
  DigitalGoodsGames = 'DigitalGoodsGames',
  DigitalGoodsLargeVolume = 'DigitalGoodsLargeVolume',
  DigitalGoodsMedia = 'DigitalGoodsMedia',
  DillonInn = 'DillonInn',
  DirectMarketingCatalogMerchant = 'DirectMarketingCatalogMerchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'DirectMarketingCombinationCatalogAndRetailMerchant',
  DirectMarketingInboundTelemarketing = 'DirectMarketingInboundTelemarketing',
  DirectMarketingInsuranceServices = 'DirectMarketingInsuranceServices',
  DirectMarketingOther = 'DirectMarketingOther',
  DirectMarketingOutboundTelemarketing = 'DirectMarketingOutboundTelemarketing',
  DirectMarketingSubscription = 'DirectMarketingSubscription',
  DirectMarketingTravel = 'DirectMarketingTravel',
  DiscountStores = 'DiscountStores',
  DisneylandResorts = 'DisneylandResorts',
  Doctors = 'Doctors',
  DollarRentACar = 'DollarRentACar',
  DominicaAir = 'DominicaAir',
  DoorToDoorSales = 'DoorToDoorSales',
  DoralGolfResort = 'DoralGolfResort',
  DoralHotels = 'DoralHotels',
  DorintHotels = 'DorintHotels',
  Doubletree = 'Doubletree',
  DowntownerPassport = 'DowntownerPassport',
  DraperyWindowCoveringAndUpholsteryStores = 'DraperyWindowCoveringAndUpholsteryStores',
  DrinkingPlaces = 'DrinkingPlaces',
  DrugStoresAndPharmacies = 'DrugStoresAndPharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'DrugsDrugProprietariesAndDruggistSundries',
  DruryInn = 'DruryInn',
  DryCleaners = 'DryCleaners',
  DunfeyHotels = 'DunfeyHotels',
  DurableGoods = 'DurableGoods',
  DutyFreeStores = 'DutyFreeStores',
  EasyjetAir = 'EasyjetAir',
  EatingPlacesRestaurants = 'EatingPlacesRestaurants',
  EconoCarRentACar = 'EconoCarRentACar',
  EconoTravelMotorHotel = 'EconoTravelMotorHotel',
  EconomyInnsOfAmerica = 'EconomyInnsOfAmerica',
  Ecuatoriana = 'Ecuatoriana',
  Edition = 'Edition',
  EducationalServices = 'EducationalServices',
  EgyptAir = 'EgyptAir',
  ElAlAirlines = 'ElAlAirlines',
  EldoradoHotelAndCasino = 'EldoradoHotelAndCasino',
  ElectricRazorStores = 'ElectricRazorStores',
  ElectricVehicleCharging = 'ElectricVehicleCharging',
  ElectricalPartsAndEquipment = 'ElectricalPartsAndEquipment',
  ElectricalServices = 'ElectricalServices',
  ElectronicsRepairShops = 'ElectronicsRepairShops',
  ElectronicsStores = 'ElectronicsStores',
  Element = 'Element',
  ElementarySecondarySchools = 'ElementarySecondarySchools',
  EmbassyHotels = 'EmbassyHotels',
  EmbassySuites = 'EmbassySuites',
  EmbassyVacationResort = 'EmbassyVacationResort',
  Emirates = 'Emirates',
  EmploymentTempAgencies = 'EmploymentTempAgencies',
  EnterpriseRentACar = 'EnterpriseRentACar',
  EquipmentRental = 'EquipmentRental',
  EthiopianAirlines = 'EthiopianAirlines',
  EtihadAir = 'EtihadAir',
  Europcar = 'Europcar',
  EuropeByCar = 'EuropeByCar',
  EvaAirways = 'EvaAirways',
  ExcaliburHotelAndCasino = 'ExcaliburHotelAndCasino',
  ExcelInn = 'ExcelInn',
  ExtendedStay = 'ExtendedStay',
  ExtendedStayAmerica = 'ExtendedStayAmerica',
  ExtendedStayDeluxe = 'ExtendedStayDeluxe',
  ExterminatingServices = 'ExterminatingServices',
  FairfieldHotel = 'FairfieldHotel',
  FairfieldInn = 'FairfieldInn',
  FairmontHotelsCorporation = 'FairmontHotelsCorporation',
  FamilyClothingStores = 'FamilyClothingStores',
  FastFood = 'FastFood',
  FastFoodRestaurants = 'FastFoodRestaurants',
  FinancialInstitutions = 'FinancialInstitutions',
  FinesGovernmentAdministrativeEntities = 'FinesGovernmentAdministrativeEntities',
  Finnair = 'Finnair',
  FireplaceFireplaceScreensAndAccessoriesStores = 'FireplaceFireplaceScreensAndAccessoriesStores',
  FirstHospitalityHotels = 'FirstHospitalityHotels',
  FlagInns = 'FlagInns',
  FlagInnsAustralia = 'FlagInnsAustralia',
  FloorCoveringStores = 'FloorCoveringStores',
  Florists = 'Florists',
  FloristsSuppliesNurseryStockAndFlowers = 'FloristsSuppliesNurseryStockAndFlowers',
  Flybe = 'Flybe',
  FontainebleauResort = 'FontainebleauResort',
  FourPointsHotels = 'FourPointsHotels',
  FourSeasons = 'FourSeasons',
  FourSeasonsAustralia = 'FourSeasonsAustralia',
  FrankenmuthBavarian = 'FrankenmuthBavarian',
  FreedomAirlines = 'FreedomAirlines',
  FreezerAndLockerMeatProvisioners = 'FreezerAndLockerMeatProvisioners',
  FremontHotelAndCasino = 'FremontHotelAndCasino',
  FriendshipInnsInternational = 'FriendshipInnsInternational',
  FrontierAirlines = 'FrontierAirlines',
  FuelDealersNonAutomotive = 'FuelDealersNonAutomotive',
  FundingTransaction = 'FundingTransaction',
  FuneralServicesCrematories = 'FuneralServicesCrematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances',
  FurnitureRepairRefinishing = 'FurnitureRepairRefinishing',
  FurriersAndFurShops = 'FurriersAndFurShops',
  GaltHouse = 'GaltHouse',
  GardenPlaceHotel = 'GardenPlaceHotel',
  Garuda = 'Garuda',
  GaylordOpryland = 'GaylordOpryland',
  GaylordPalms = 'GaylordPalms',
  GaylordTexan = 'GaylordTexan',
  GeneralRentACar = 'GeneralRentACar',
  GeneralServices = 'GeneralServices',
  GiftCardNoveltyAndSouvenirShops = 'GiftCardNoveltyAndSouvenirShops',
  GlassPaintAndWallpaperStores = 'GlassPaintAndWallpaperStores',
  GlasswareCrystalStores = 'GlasswareCrystalStores',
  GodfreyNational = 'GodfreyNational',
  Gofly = 'Gofly',
  GolAirlines = 'GolAirlines',
  GoldenNugget = 'GoldenNugget',
  GoldenPacificAir = 'GoldenPacificAir',
  GoldenTulip = 'GoldenTulip',
  GolfCoursesPublic = 'GolfCoursesPublic',
  GovernmentLicensedHorseOrDogRacing = 'GovernmentLicensedHorseOrDogRacing',
  GovernmentLicensedOnLineCasino = 'GovernmentLicensedOnLineCasino',
  GovernmentOwnedLottery = 'GovernmentOwnedLottery',
  GovernmentOwnedLotteryGlobal = 'GovernmentOwnedLotteryGlobal',
  GovernmentServices = 'GovernmentServices',
  GranbellHotelsAndResort = 'GranbellHotelsAndResort',
  GrandCasinoHotels = 'GrandCasinoHotels',
  GrandMetForumHotels = 'GrandMetForumHotels',
  GrandSierraResort = 'GrandSierraResort',
  GrandWaileaResort = 'GrandWaileaResort',
  GreatWolf = 'GreatWolf',
  GreenbriarResorts = 'GreenbriarResorts',
  GroceryStoresSupermarkets = 'GroceryStoresSupermarkets',
  GrupoHotelsHusaSa = 'GrupoHotelsHusaSa',
  GulfAir = 'GulfAir',
  GunsAmmo = 'GunsAmmo',
  GuyanaAirways = 'GuyanaAirways',
  HainanAirlines = 'HainanAirlines',
  HaleKoaHotel = 'HaleKoaHotel',
  HalekulaniHotelWaikikiParc = 'HalekulaniHotelWaikikiParc',
  HamptonInns = 'HamptonInns',
  HardwareEquipmentAndSupplies = 'HardwareEquipmentAndSupplies',
  HardwareStores = 'HardwareStores',
  HarleyHotel = 'HarleyHotel',
  HarrahsHotelsAndCasinos = 'HarrahsHotelsAndCasinos',
  HarveyBristolHotels = 'HarveyBristolHotels',
  HavasuAirlines = 'HavasuAirlines',
  HawaiianAir = 'HawaiianAir',
  HealthAndBeautySpas = 'HealthAndBeautySpas',
  HearingAidsSalesAndSupplies = 'HearingAidsSalesAndSupplies',
  HeatingPlumbingAc = 'HeatingPlumbingAC',
  HelmsleyHotels = 'HelmsleyHotels',
  HermitageHotels = 'HermitageHotels',
  Hertz = 'Hertz',
  Hilton = 'Hilton',
  HiltonGardenInn = 'HiltonGardenInn',
  HiltonInternational = 'HiltonInternational',
  HlxAir = 'HlxAir',
  HobbyToyAndGameShops = 'HobbyToyAndGameShops',
  HolidayInns = 'HolidayInns',
  HolidayRentACar = 'HolidayRentACar',
  Home2Suites = 'Home2Suites',
  HomeSupplyWarehouseStores = 'HomeSupplyWarehouseStores',
  Home_2Suites = 'Home_2Suites',
  Homestead = 'Homestead',
  HomesteadSuites = 'HomesteadSuites',
  HomewoodSuites = 'HomewoodSuites',
  HospitalityInns = 'HospitalityInns',
  Hospitals = 'Hospitals',
  HoteisOthan = 'HoteisOthan',
  HotelDelCoronado = 'HotelDelCoronado',
  HotelIndigo = 'HotelIndigo',
  HotelMercure = 'HotelMercure',
  HotelOkura = 'HotelOkura',
  HotelSierra = 'HotelSierra',
  HotelUniversal = 'HotelUniversal',
  HotelesElPresidente = 'HotelesElPresidente',
  HotelsMelia = 'HotelsMelia',
  HotelsMotelsAndResorts = 'HotelsMotelsAndResorts',
  HouseholdApplianceStores = 'HouseholdApplianceStores',
  HowardJohnson = 'HowardJohnson',
  HudsonHotel = 'HudsonHotel',
  HungarHotels = 'HungarHotels',
  HyattHotelsInternational = 'HyattHotelsInternational',
  HyattPlace = 'HyattPlace',
  Iberia = 'Iberia',
  Iberotel = 'Iberotel',
  IbuszHotels = 'IbuszHotels',
  IcelandAir = 'IcelandAir',
  ImperialLondonHotels = 'ImperialLondonHotels',
  IndianAirlines = 'IndianAirlines',
  IndustrialSupplies = 'IndustrialSupplies',
  InformationRetrievalServices = 'InformationRetrievalServices',
  InsuranceAgentsBrokersService = 'InsuranceAgentsBrokersService',
  InsuranceDefault = 'InsuranceDefault',
  InsurancePremiums = 'InsurancePremiums',
  InsuranceRentACar = 'InsuranceRentACar',
  InsuranceUnderwritingPremiums = 'InsuranceUnderwritingPremiums',
  InterNorHotels = 'InterNorHotels',
  Intercontinental = 'Intercontinental',
  Interent = 'Interent',
  InterhotelCedok = 'InterhotelCedok',
  IntraCompanyPurchases = 'IntraCompanyPurchases',
  IslandAirlines = 'IslandAirlines',
  JapanAirlines = 'JapanAirlines',
  JeffersonHotel = 'JeffersonHotel',
  JetAirways = 'JetAirways',
  JetblueAirways = 'JetblueAirways',
  JetstarAirways = 'JetstarAirways',
  JewelryStoresWatchesClocksAndSilverwareStores = 'JewelryStoresWatchesClocksAndSilverwareStores',
  JohnAscuagasNugget = 'JohnAscuagasNugget',
  JollyHotels = 'JollyHotels',
  JourneysEndMotels = 'JourneysEndMotels',
  JugoslavAir = 'JugoslavAir',
  JumeirahEssexHouse = 'JumeirahEssexHouse',
  JurysDoyleHotelGroup = 'JurysDoyleHotelGroup',
  JwMarriott = 'JwMarriott',
  KahalaMandarinOrientalHotel = 'KahalaMandarinOrientalHotel',
  KarosHotels = 'KarosHotels',
  KauaiCoconutBeachResort = 'KauaiCoconutBeachResort',
  KemwellGroup = 'KemwellGroup',
  KenyaAirways = 'KenyaAirways',
  KlmRoyalDutchAirlines = 'KlmRoyalDutchAirlines',
  KnightsInn = 'KnightsInn',
  KoreanAirlines = 'KoreanAirlines',
  KuwaitAir = 'KuwaitAir',
  Kyoritsuhotels = 'Kyoritsuhotels',
  LaCostaResort = 'LaCostaResort',
  LaMansionDelRio = 'LaMansionDelRio',
  LaQuintaMotorInns = 'LaQuintaMotorInns',
  LaQuintaResort = 'LaQuintaResort',
  LabAir = 'LabAir',
  LacsaAir = 'LacsaAir',
  LadbrokeHotels = 'LadbrokeHotels',
  LadecoAir = 'LadecoAir',
  LadyLuckHotelAndCasino = 'LadyLuckHotelAndCasino',
  LanAir = 'LanAir',
  LandscapingServices = 'LandscapingServices',
  LapAir = 'LapAir',
  Laundries = 'Laundries',
  LaundryCleaningServices = 'LaundryCleaningServices',
  LavAir = 'LavAir',
  LegalServicesAttorneys = 'LegalServicesAttorneys',
  LiatAirline = 'LiatAirline',
  LoewsHotels = 'LoewsHotels',
  LotAir = 'LotAir',
  Lufthansa = 'Lufthansa',
  LuggageAndLeatherGoodsStores = 'LuggageAndLeatherGoodsStores',
  LumberBuildingMaterialsStores = 'LumberBuildingMaterialsStores',
  Luxair = 'Luxair',
  LuxorHotelAndCasino = 'LuxorHotelAndCasino',
  LuxuryResorts = 'LuxuryResorts',
  MainStreetStationHotelAndCasino = 'MainStreetStationHotelAndCasino',
  MainstaySuites = 'MainstaySuites',
  MajorRentACar = 'MajorRentACar',
  MalaysianAirlineSystem = 'MalaysianAirlineSystem',
  Malev = 'Malev',
  MalmoAir = 'MalmoAir',
  MandalayBayResort = 'MandalayBayResort',
  MandarinInternational = 'MandarinInternational',
  ManhattanEastSuiteHotels = 'ManhattanEastSuiteHotels',
  ManualCashDisburse = 'ManualCashDisburse',
  MarinasServiceAndSupplies = 'MarinasServiceAndSupplies',
  Maritim = 'Maritim',
  Marriott = 'Marriott',
  MarriottExecutiveApartments = 'MarriottExecutiveApartments',
  MasonryStoneworkAndPlaster = 'MasonryStoneworkAndPlaster',
  MassageParlors = 'MassageParlors',
  MastersEconomyInns = 'MastersEconomyInns',
  MedicalAndDentalLabs = 'MedicalAndDentalLabs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies',
  MedicalServices = 'MedicalServices',
  MembershipOrganizations = 'MembershipOrganizations',
  MensAndBoysClothingAndAccessoriesStores = 'MensAndBoysClothingAndAccessoriesStores',
  MensWomensClothingStores = 'MensWomensClothingStores',
  MerchantsRentACar = 'MerchantsRentACar',
  Meridien = 'Meridien',
  MerlinHotelPerth = 'MerlinHotelPerth',
  MesaAir = 'MesaAir',
  MetalServiceCenters = 'MetalServiceCenters',
  MetroAirlines = 'MetroAirlines',
  MetroflightAirlines = 'MetroflightAirlines',
  MetropoleHotels = 'MetropoleHotels',
  MexicanaAirlines = 'MexicanaAirlines',
  MgmGrandHotel = 'MgmGrandHotel',
  MicrotelInnAndSuites = 'MicrotelInnAndSuites',
  MiddleEastAir = 'MiddleEastAir',
  MidwayMotorLodge = 'MidwayMotorLodge',
  MidwestExpressAirlines = 'MidwestExpressAirlines',
  MillenniumBroadwayHotel = 'MillenniumBroadwayHotel',
  Milleville = 'Milleville',
  Minacia = 'Minacia',
  MirageHotelAndCasino = 'MirageHotelAndCasino',
  MiscellaneousApparelAndAccessoryShops = 'MiscellaneousApparelAndAccessoryShops',
  MiscellaneousAutoDealers = 'MiscellaneousAutoDealers',
  MiscellaneousBusinessServices = 'MiscellaneousBusinessServices',
  MiscellaneousFoodStores = 'MiscellaneousFoodStores',
  MiscellaneousGeneralMerchandise = 'MiscellaneousGeneralMerchandise',
  MiscellaneousGeneralServices = 'MiscellaneousGeneralServices',
  MiscellaneousHomeFurnishingSpecialtyStores = 'MiscellaneousHomeFurnishingSpecialtyStores',
  MiscellaneousPublishingAndPrinting = 'MiscellaneousPublishingAndPrinting',
  MiscellaneousRecreationServices = 'MiscellaneousRecreationServices',
  MiscellaneousRepairShops = 'MiscellaneousRepairShops',
  MiscellaneousSpecialtyRetail = 'MiscellaneousSpecialtyRetail',
  MiyakoHotelKintetsu = 'MiyakoHotelKintetsu',
  MobileHomeDealers = 'MobileHomeDealers',
  Moevenpick = 'Moevenpick',
  MoneysendFunding = 'MoneysendFunding',
  MoneysendIntercountry = 'MoneysendIntercountry',
  MoneysendIntracountry = 'MoneysendIntracountry',
  MonteCarloHotelAndCasino = 'MonteCarloHotelAndCasino',
  MortgageBankersLoanCorrespondents = 'MortgageBankersLoanCorrespondents',
  Motel_6 = 'Motel_6',
  MotionPictureTheaters = 'MotionPictureTheaters',
  MotorFreightCarriersAndTrucking = 'MotorFreightCarriersAndTrucking',
  MotorHomesDealers = 'MotorHomesDealers',
  MotorVehicleSuppliesAndNewParts = 'MotorVehicleSuppliesAndNewParts',
  MotorcycleShopsAndDealers = 'MotorcycleShopsAndDealers',
  MotorcycleShopsDealers = 'MotorcycleShopsDealers',
  MountCharlotteHotels = 'MountCharlotteHotels',
  MountCook = 'MountCook',
  Moxy = 'Moxy',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'MusicStoresMusicalInstrumentsPianosAndSheetMusic',
  Nationair = 'Nationair',
  NationalCarRental = 'NationalCarRental',
  NemacolinWoodlands = 'NemacolinWoodlands',
  NeveleGrandeResortAndCountryClub = 'NeveleGrandeResortAndCountryClub',
  NewOtaniHotels = 'NewOtaniHotels',
  NewYorkNewYorkHotelAndCasino = 'NewYorkNewYorkHotelAndCasino',
  NewsDealersAndNewsstands = 'NewsDealersAndNewsstands',
  NickelodeonFamilySuitesByHolidayInn = 'NickelodeonFamilySuitesByHolidayInn',
  NigeriaAir = 'NigeriaAir',
  NoahsHotelMelbourne = 'NoahsHotelMelbourne',
  NonFiMoneyOrders = 'NonFiMoneyOrders',
  NonFiStoredValueCardPurchaseLoad = 'NonFiStoredValueCardPurchaseLoad',
  NondurableGoods = 'NondurableGoods',
  NordAir = 'NordAir',
  Norontair = 'Norontair',
  NorwegianAirShuttle = 'NorwegianAirShuttle',
  NovotelSiehAccor = 'NovotelSiehAccor',
  NurseriesLawnAndGardenSupplyStores = 'NurseriesLawnAndGardenSupplyStores',
  NursingPersonalCare = 'NursingPersonalCare',
  NwaAir = 'NwaAir',
  NyHeli = 'NyHeli',
  OberoiHotels = 'OberoiHotels',
  OfficeAndCommercialFurniture = 'OfficeAndCommercialFurniture',
  OhanaHotelsOfHawaii = 'OhanaHotelsOfHawaii',
  OlympicAirways = 'OlympicAirways',
  OmanAir = 'OmanAir',
  OmniInternational = 'OmniInternational',
  OnlineMarketplaces = 'OnlineMarketplaces',
  OprylandHotel = 'OprylandHotel',
  OpticiansEyeglasses = 'OpticiansEyeglasses',
  OptometristsOphthalmologist = 'OptometristsOphthalmologist',
  OrchidAtMaunaLai = 'OrchidAtMaunaLai',
  OrthopedicGoodsProstheticDevices = 'OrthopedicGoodsProstheticDevices',
  Osteopaths = 'Osteopaths',
  OutriggerHotelsAndResorts = 'OutriggerHotelsAndResorts',
  OxfordSuites = 'OxfordSuites',
  PackageStoresBeerWineAndLiquor = 'PackageStoresBeerWineAndLiquor',
  PaintsVarnishesAndSupplies = 'PaintsVarnishesAndSupplies',
  PakistanInternational = 'PakistanInternational',
  PanAmerican = 'PanAmerican',
  PannoniaHotels = 'PannoniaHotels',
  ParisLasVegasHotel = 'ParisLasVegasHotel',
  ParkInnByRadisson = 'ParkInnByRadisson',
  ParkPlazaHotel = 'ParkPlazaHotel',
  ParkingLotsGarages = 'ParkingLotsGarages',
  ParksInnsInternational = 'ParksInnsInternational',
  PassengerRailways = 'PassengerRailways',
  PatriciaGrandResortHotels = 'PatriciaGrandResortHotels',
  PawnShops = 'PawnShops',
  PaylessCarRental = 'PaylessCarRental',
  PbaAirline = 'PbaAirline',
  PeabodyHotels = 'PeabodyHotels',
  PeninsulaHotels = 'PeninsulaHotels',
  PentaHotels = 'PentaHotels',
  PeppermillHotelCasino = 'PeppermillHotelCasino',
  PersonalCreditInstitutions = 'PersonalCreditInstitutions',
  PetShopsPetFoodAndSupplies = 'PetShopsPetFoodAndSupplies',
  PetroleumAndPetroleumProducts = 'PetroleumAndPetroleumProducts',
  PhilippineAirlines = 'PhilippineAirlines',
  PhotoDeveloping = 'PhotoDeveloping',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'PhotographicPhotocopyMicrofilmEquipmentAndSupplies',
  PhotographicStudios = 'PhotographicStudios',
  PictureVideoProduction = 'PictureVideoProduction',
  PieceGoodsNotionsAndOtherDryGoods = 'PieceGoodsNotionsAndOtherDryGoods',
  PinehurstResort = 'PinehurstResort',
  PinlessDebitBillpayTier_2 = 'PinlessDebitBillpayTier_2',
  PlmEtapInternational = 'PlmEtapInternational',
  PlumbingHeatingEquipmentAndSupplies = 'PlumbingHeatingEquipmentAndSupplies',
  PoliticalOrganizations = 'PoliticalOrganizations',
  PostalServicesGovernmentOnly = 'PostalServicesGovernmentOnly',
  PreciousStonesAndMetalsWatchesAndJewelry = 'PreciousStonesAndMetalsWatchesAndJewelry',
  PremierTravelInns = 'PremierTravelInns',
  PrimadonnaHotelAndCasino = 'PrimadonnaHotelAndCasino',
  PrinceHotels = 'PrinceHotels',
  PrincessHotelsInternational = 'PrincessHotelsInternational',
  PrincevilleAir = 'PrincevilleAir',
  PrincevilleResort = 'PrincevilleResort',
  ProfessionalServices = 'ProfessionalServices',
  ProteaHotels = 'ProteaHotels',
  PublicWarehousingAndStorage = 'PublicWarehousingAndStorage',
  QatarAirways = 'QatarAirways',
  QualityInternational = 'QualityInternational',
  QualityPacificHotel = 'QualityPacificHotel',
  Quantas = 'Quantas',
  QuasiCashCustomerFinancialInstitutions = 'QuasiCashCustomerFinancialInstitutions',
  QueensMoatHouses = 'QueensMoatHouses',
  QuickCopyReproAndBlueprint = 'QuickCopyReproAndBlueprint',
  Radisson = 'Radisson',
  RadissonBlu = 'RadissonBlu',
  RafflesHotels = 'RafflesHotels',
  Railroads = 'Railroads',
  RamadaInns = 'RamadaInns',
  RankHotels = 'RankHotels',
  RantasipiHotels = 'RantasipiHotels',
  RealEstateAgentsAndManagersRentals = 'RealEstateAgentsAndManagersRentals',
  RecordStores = 'RecordStores',
  RecreationalVehicleRentals = 'RecreationalVehicleRentals',
  RedRoofInns = 'RedRoofInns',
  Regal_8Inns = 'Regal_8Inns',
  RegentHotels = 'RegentHotels',
  RegistryHotels = 'RegistryHotels',
  RelaxInns = 'RelaxInns',
  ReligiousGoodsStores = 'ReligiousGoodsStores',
  ReligiousOrganizations = 'ReligiousOrganizations',
  RenaissanceHotels = 'RenaissanceHotels',
  RenoAir = 'RenoAir',
  RentAWreck = 'RentAWreck',
  ReplacementRentACar = 'ReplacementRentACar',
  ReserveRentACar = 'ReserveRentACar',
  ResidenceInn = 'ResidenceInn',
  ResoHotels = 'ResoHotels',
  RicaHotels = 'RicaHotels',
  RioHotels = 'RioHotels',
  RioSuites = 'RioSuites',
  RitzCarlton = 'RitzCarlton',
  RiversideResortAndCasino = 'RiversideResortAndCasino',
  RivieraHotelAndCasino = 'RivieraHotelAndCasino',
  RiyadhAir = 'RiyadhAir',
  RodewayInnsInternational = 'RodewayInnsInternational',
  RoofingSidingSheetMetal = 'RoofingSidingSheetMetal',
  RosenHotelAndResorts = 'RosenHotelAndResorts',
  RoyalHotels = 'RoyalHotels',
  RoyalKonaResort = 'RoyalKonaResort',
  RoyceHotel = 'RoyceHotel',
  Ryanair = 'Ryanair',
  Sabena = 'Sabena',
  SaddlebrookResortTampa = 'SaddlebrookResortTampa',
  SaetaAir = 'SaetaAir',
  SaharaHotelAndCasino = 'SaharaHotelAndCasino',
  SahsaAir = 'SahsaAir',
  SamsTownHotelAndCasino = 'SamsTownHotelAndCasino',
  SanJuanAir = 'SanJuanAir',
  SandmanHotels = 'SandmanHotels',
  SandmanInn = 'SandmanInn',
  SandsResort = 'SandsResort',
  SaraHotels = 'SaraHotels',
  SarovaHotels = 'SarovaHotels',
  SaudiaArabianAirlines = 'SaudiaArabianAirlines',
  ScandicHotels = 'ScandicHotels',
  ScandinavianAirlineSystem = 'ScandinavianAirlineSystem',
  ScenicAirlines = 'ScenicAirlines',
  SeaPinesResort = 'SeaPinesResort',
  SecretarialSupportServices = 'SecretarialSupportServices',
  SecurityBrokersDealers = 'SecurityBrokersDealers',
  ServiceStations = 'ServiceStations',
  SettleInn = 'SettleInn',
  SewingNeedleworkFabricAndPieceGoodsStores = 'SewingNeedleworkFabricAndPieceGoodsStores',
  ShangriLaInternational = 'ShangriLaInternational',
  Sheraton = 'Sheraton',
  ShiloInn = 'ShiloInn',
  ShoeRepairHatCleaning = 'ShoeRepairHatCleaning',
  ShoeStores = 'ShoeStores',
  ShoneysInn = 'ShoneysInn',
  ShowcaseRentalCars = 'ShowcaseRentalCars',
  SilverLegacyHotelAndCasino = 'SilverLegacyHotelAndCasino',
  SilverStarHotelAndCasino = 'SilverStarHotelAndCasino',
  SimmonsAirlines = 'SimmonsAirlines',
  SingaporeAirlines = 'SingaporeAirlines',
  SingletonAir = 'SingletonAir',
  SixtCarRental = 'SixtCarRental',
  SkywaysAir = 'SkywaysAir',
  SleepInn = 'SleepInn',
  SmallApplianceRepair = 'SmallApplianceRepair',
  SmugglersNotchResort = 'SmugglersNotchResort',
  SnappyCarRental = 'SnappyCarRental',
  SnowmobileDealers = 'SnowmobileDealers',
  SofitelHotels = 'SofitelHotels',
  SohoGrandHotel = 'SohoGrandHotel',
  SokosHotel = 'SokosHotel',
  SolHotels = 'SolHotels',
  SonestaInternationalHotels = 'SonestaInternationalHotels',
  SouthAfricanAirways = 'SouthAfricanAirways',
  SouthernPacificHotel = 'SouthernPacificHotel',
  SouthernSunHotels = 'SouthernSunHotels',
  SouthwestAirlines = 'SouthwestAirlines',
  Spanair = 'Spanair',
  SpecialTradeServices = 'SpecialTradeServices',
  SpecialtyCleaning = 'SpecialtyCleaning',
  SpiritAirlines = 'SpiritAirlines',
  SportingGoodsStores = 'SportingGoodsStores',
  SportingRecreationCamps = 'SportingRecreationCamps',
  SportsAndRidingApparelStores = 'SportsAndRidingApparelStores',
  SportsClubsFields = 'SportsClubsFields',
  SpringhillSuites = 'SpringhillSuites',
  StRegisHotel = 'StRegisHotel',
  StakisHotels = 'StakisHotels',
  StampAndCoinStores = 'StampAndCoinStores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'StationaryOfficeSuppliesPrintingAndWritingPaper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'StationeryStoresOfficeAndSchoolSupplyStores',
  StaybridgeSuites = 'StaybridgeSuites',
  Steigenberger = 'Steigenberger',
  StratosphereHotelAndCasino = 'StratosphereHotelAndCasino',
  StudioPlus = 'StudioPlus',
  SudanAirways = 'SudanAirways',
  SuisseChalet = 'SuisseChalet',
  SummerfieldSuitesHotel = 'SummerfieldSuitesHotel',
  SunCountryAirlines = 'SunCountryAirlines',
  SunbeltAirlines = 'SunbeltAirlines',
  SunworldAir = 'SunworldAir',
  Super_8Motel = 'Super_8Motel',
  SurinamAirways = 'SurinamAirways',
  SwallowHotels = 'SwallowHotels',
  SwimmingPoolsSales = 'SwimmingPoolsSales',
  SwissAir = 'SwissAir',
  Swissotel = 'Swissotel',
  TUiTravelGermany = 'TUiTravelGermany',
  TacaInternationalAir = 'TacaInternationalAir',
  TailorsAlterations = 'TailorsAlterations',
  TajHotelsIntl = 'TajHotelsIntl',
  TalAir = 'TalAir',
  TamAirlines = 'TamAirlines',
  TameAir = 'TameAir',
  TanAir = 'TanAir',
  TapAirPortugal = 'TapAirPortugal',
  TaromAir = 'TaromAir',
  TaxPaymentsGovernmentAgencies = 'TaxPaymentsGovernmentAgencies',
  TaxPreparationServices = 'TaxPreparationServices',
  TaxicabsLimousines = 'TaxicabsLimousines',
  TelecommunicationEquipmentAndTelephoneSales = 'TelecommunicationEquipmentAndTelephoneSales',
  TelecommunicationServices = 'TelecommunicationServices',
  TelegraphServices = 'TelegraphServices',
  TentAndAwningShops = 'TentAndAwningShops',
  TestingLaboratories = 'TestingLaboratories',
  ThaiAirways = 'ThaiAirways',
  TheAtlantic = 'TheAtlantic',
  TheDiplomatCountryClubAndSpa = 'TheDiplomatCountryClubAndSpa',
  TheEliotHotel = 'TheEliotHotel',
  TheFlamingoHotels = 'TheFlamingoHotels',
  TheLuxuryCollection = 'TheLuxuryCollection',
  ThePalaceHotel = 'ThePalaceHotel',
  ThePhoenician = 'ThePhoenician',
  TheRooseveltHotelNy = 'TheRooseveltHotelNy',
  TheWigwamGolfResortAndSpa = 'TheWigwamGolfResortAndSpa',
  TheatricalTicketAgencies = 'TheatricalTicketAgencies',
  ThriftyCarRental = 'ThriftyCarRental',
  ThunderbirdRedLion = 'ThunderbirdRedLion',
  ThyAirline = 'ThyAirline',
  Tigerair = 'Tigerair',
  TildenRentACar = 'TildenRentACar',
  Timeshares = 'Timeshares',
  TireRetreadingAndRepair = 'TireRetreadingAndRepair',
  TokyoGroup = 'TokyoGroup',
  TollsBridgeFees = 'TollsBridgeFees',
  TouristAttractionsAndExhibits = 'TouristAttractionsAndExhibits',
  TowerAir = 'TowerAir',
  TowingServices = 'TowingServices',
  TownAndCountryResortAndConventionCenter = 'TownAndCountryResortAndConventionCenter',
  TowneplaceSuites = 'TowneplaceSuites',
  TradewindsResort = 'TradewindsResort',
  TrailerParksCampgrounds = 'TrailerParksCampgrounds',
  TransWorldAirlines = 'TransWorldAirlines',
  Transaero = 'Transaero',
  TransportationServices = 'TransportationServices',
  TravelAgenciesTourOperators = 'TravelAgenciesTourOperators',
  TravelodgeMotels = 'TravelodgeMotels',
  TreasureIslandHotelAndCasino = 'TreasureIslandHotelAndCasino',
  TriangleRentACar = 'TriangleRentACar',
  TribecaGrandHotel = 'TribecaGrandHotel',
  TributePortfolio = 'TributePortfolio',
  TropicalRentACar = 'TropicalRentACar',
  TropicanaResortAndCasino = 'TropicanaResortAndCasino',
  TruckStopIteration = 'TruckStopIteration',
  TruckUtilityTrailerRentals = 'TruckUtilityTrailerRentals',
  TrusthouseForte = 'TrusthouseForte',
  TunisAir = 'TunisAir',
  TypesettingPlateMakingAndRelatedServices = 'TypesettingPlateMakingAndRelatedServices',
  TypewriterStores = 'TypewriterStores',
  UglyDucklingRentACar = 'UglyDucklingRentACar',
  UniAirwaysCorporation = 'UniAirwaysCorporation',
  UniformsCommercialClothing = 'UniformsCommercialClothing',
  UnitedAirlines = 'UnitedAirlines',
  UsAirShuttle = 'UsAirShuttle',
  UsAirways = 'UsAirways',
  UsFederalGovernmentAgenciesOrDepartments = 'UsFederalGovernmentAgenciesOrDepartments',
  UsaRental = 'UsaRental',
  UsedMerchandiseAndSecondhandStores = 'UsedMerchandiseAndSecondhandStores',
  UtaInterair = 'UtaInterair',
  Utilities = 'Utilities',
  VagabondHotels = 'VagabondHotels',
  ValleyAirlines = 'ValleyAirlines',
  ValueRentACar = 'ValueRentACar',
  VanguardAir = 'VanguardAir',
  VarietyStores = 'VarietyStores',
  Varig = 'Varig',
  VaspAir = 'VaspAir',
  Vdara = 'Vdara',
  VenetianResortHotelAndCasino = 'VenetianResortHotelAndCasino',
  VentureInn = 'VentureInn',
  VeterinaryServices = 'VeterinaryServices',
  ViasaAir = 'ViasaAir',
  VideoAmusementGameSupplies = 'VideoAmusementGameSupplies',
  VideoGameArcades = 'VideoGameArcades',
  VideoTapeRentalStores = 'VideoTapeRentalStores',
  VirginAmerica = 'VirginAmerica',
  VirginAtlantic = 'VirginAtlantic',
  VirginExpressAir = 'VirginExpressAir',
  VirginRiverHotelAndCasino = 'VirginRiverHotelAndCasino',
  VlmAirlines = 'VlmAirlines',
  VocationalTradeSchools = 'VocationalTradeSchools',
  WHotels = 'WHotels',
  Waldorf = 'Waldorf',
  WatchJewelryRepair = 'WatchJewelryRepair',
  Welcomgroup = 'Welcomgroup',
  WeldingRepair = 'WeldingRepair',
  WellesleyInns = 'WellesleyInns',
  WestinHotels = 'WestinHotels',
  WestjetAirlines = 'WestjetAirlines',
  WhiskeyPetesHotelAndCasino = 'WhiskeyPetesHotelAndCasino',
  Wholesale = 'Wholesale',
  WholesaleClubs = 'WholesaleClubs',
  Wideroes = 'Wideroes',
  WigAndToupeeStores = 'WigAndToupeeStores',
  WildernessHotelAndResort = 'WildernessHotelAndResort',
  WindwardIslandAir = 'WindwardIslandAir',
  WineProducers = 'WineProducers',
  WingsAirways = 'WingsAirways',
  WiresMoneyOrders = 'WiresMoneyOrders',
  WizzAir = 'WizzAir',
  WomensAccessoryAndSpecialtyShops = 'WomensAccessoryAndSpecialtyShops',
  WomensReadyToWearStores = 'WomensReadyToWearStores',
  WoodsideHotelsAndResorts = 'WoodsideHotelsAndResorts',
  WreckingAndSalvageYards = 'WreckingAndSalvageYards',
  Wyndham = 'Wyndham',
  WynnLasVegas = 'WynnLasVegas',
  ZambiaAirways = 'ZambiaAirways'
}

export type MerchantDetailsResponse = {
  __typename?: 'MerchantDetailsResponse';
  address?: Maybe<Address>;
  category?: Maybe<MerchantCategory>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  countryCodeAlpha3?: Maybe<Iso3166Alpha3Country>;
  description?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MesaGenericOk = {
  __typename?: 'MesaGenericOk';
  status: MesaGenericOkStatus;
};

export enum MesaGenericOkStatus {
  Ok = 'OK'
}

export type MesaHomeEnrollment = {
  __typename?: 'MesaHomeEnrollment';
  awardSource?: Maybe<MesaHomeMonthlyAwardSource>;
  canUserEditAwardAmount?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated As enrollment is no longer based on Plaid, this field will always be null (and removed in the future) */
  enrolledItem?: Maybe<LinkedItemModel>;
  errorDisplayMessage?: Maybe<Scalars['String']['output']>;
  isEnrolled: Scalars['Boolean']['output'];
  recognizedMortgageAmount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated As enrollment is no longer based on Plaid, there is no longer a recognized mortgage date and this field will always be null (and removed in the future) */
  recognizedMortgageDate?: Maybe<Scalars['String']['output']>;
  statementCloseDate?: Maybe<Scalars['DateTime']['output']>;
  statementSpend?: Maybe<Scalars['Float']['output']>;
  statementSpendRemaining?: Maybe<Scalars['Float']['output']>;
  statementSpendThreshold?: Maybe<Scalars['Float']['output']>;
};

export type MesaHomeMonthlyAward = {
  __typename?: 'MesaHomeMonthlyAward';
  auth0UserId: Scalars['String']['output'];
  awardAmountInPoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  source?: Maybe<MesaHomeMonthlyAwardSource>;
  uploadedDocuments?: Maybe<Array<UploadedDocument>>;
  verificationStatus: MesaHomeMonthlyAwardVerificationStatus;
};

export enum MesaHomeMonthlyAwardSource {
  CardApp = 'CARD_APP',
  ManuallySetByStaff = 'MANUALLY_SET_BY_STAFF',
  UserSupplied = 'USER_SUPPLIED'
}

export enum MesaHomeMonthlyAwardVerificationStatus {
  Accepted = 'ACCEPTED',
  Loading = 'LOADING',
  Rejected = 'REJECTED'
}

export type MesaMortgageLoanPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'MesaMortgageLoanPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type MesaUserError = {
  __typename?: 'MesaUserError';
  message: Scalars['String']['output'];
};

export type MortgageAddress = {
  __typename?: 'MortgageAddress';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  plaidAccount?: Maybe<PlaidAccountResponse>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type MortgageLeadModel = {
  __typename?: 'MortgageLeadModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: MortgageLeadType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum MortgageLeadType {
  NewMortgage = 'NEW_MORTGAGE',
  Refinance = 'REFINANCE'
}

export type MortgageLoanPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'MortgageLoanPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type MortgageSpendPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'MortgageSpendPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type MortgageTransferPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'MortgageTransferPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  orderDescription: Scalars['String']['output'];
  plaidTransferId: Scalars['String']['output'];
  points: PointsLedgerAmount;
  status: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activatePaymentCard: Scalars['Boolean']['output'];
  addMortgageAddress: AddMortgageAddressResponseDto;
  addMortgageLead: AddMortgageLeadResultModel;
  addNotificationDevice: AddNotificationDeviceResponse;
  addPaymentCardToApplePayByDevicePushProvisioning: ApplePayPushProvisioningResponseDto;
  applyForCreditCardProduct: ApplyForCreditCardProductResponseDto;
  backfillPhysicalCardTrackingNumbers: Scalars['Boolean']['output'];
  backfillUsersForOLAndAscenda: Scalars['String']['output'];
  cancelScheduledTransfer: CancelScheduledTransferResult;
  closeLinkedExternalBankAccountV2: CloseLinkedExternalBankAccountResult;
  completePlaidLink: LinkResultModel;
  confirmCreditReportUnfrozen: ApplicationSubmissionScreen;
  /** @deprecated Use PlaidResolver.linkAccount instead */
  connectHighnoteAccountHolderToPlaid: Scalars['Boolean']['output'];
  createMagicLinkToLogIntoRedemptionPortal: RedemptionPortalLoginLinkResponse;
  createMesaHomeDocumentUploadLink: CreateMesaHomeDocumentUploadLinkModel;
  createNewMonthlyAward: CreateMesaHomeMonthlyAward;
  createOneTimePaymentV2: CreateOneTimePaymentResult;
  createRecurringPaymentV2: CreateRecurringPaymentResult;
  enrollInBenefit: EnrollInBenefitResponse;
  /** @deprecated Enrollment is implicit upon card creation, this endpoint is for legacy clients */
  enrollInMesaHome: MesaHomeEnrollment;
  enrollInstacartBenefit: EnrollInstacartBenefitResponse;
  enrollReferralBonusOffer: EnrollReferralBonusOfferResponse;
  generateClientToken: HighnoteClientToken;
  generateManageCardClientToken: HighnoteClientToken;
  generateStatementPdfLink: GenerateStatementPdfLinkResponseDto;
  joinWaitlist: JoinWaitlistResponseDto;
  recordSurveyResponse: AvailableSurveys;
  redeemPointsForMortgageTransfer: RedeemPointsForMortgageTransferResponsDto;
  redeemPointsForStatementCredit: Scalars['Boolean']['output'];
  redeemPointsForStatementCreditTyped: RedeemPointsForStatementCreditResult;
  refreshToken: BaseAuthTokenResponseDto;
  /** @deprecated Use internal tooling instead */
  regenerateStatement: Scalars['Boolean']['output'];
  rejectCardApplication: ApplyForCreditCardProductResponseDto;
  requestOTPCode: RequestOtpCodeResponseDto;
  retargetNotifications: Scalars['Boolean']['output'];
  retargetNotificationsEventsById: Scalars['Boolean']['output'];
  sendPhoneVerificationCode: SendPhoneVerificationCodeResponse;
  sendPhoneVerificationCodeForNewAccount: SendPhoneVerificationCodeResult;
  setAppsFlyerId: SetAppsFlyerIdResponse;
  simulateShiftStatementEndAndRolloverToNextBillingCycle: Scalars['Boolean']['output'];
  submitCardApplicationToHighnote: ApplyForCreditCardProductResponseDto;
  submitMortgageLead: SubmitMortgageLeadResponse;
  syncCardInviteCodesToBraze: Scalars['Boolean']['output'];
  updateAllNotificationsPushStatusTo: UpdateAllNotificationPushStatusToResponse;
  updateLatestMonthlyAward: UpdateMesaHomeMonthlyAward;
  updateMonthlyAward: UpdateAwardResult;
  updateNotificationPushStatus: UpdateNotificationPushStatusResponse;
  updateNotificationSettings: UpdateNotificationSettingsResponse;
  updateUserAddress: Scalars['Boolean']['output'];
  updateUserInformation: GetUserInfoResponse;
  updateUserMetadata: Scalars['Boolean']['output'];
  validateHighnoteAddress: ValidateAddressResponseDto;
  validateOtpCode: AuthTokenResponseDto;
  validatePhoneVerificationCode: ValidatePhoneVerificationCodeResponse;
  verifyCardInviteCode: VerifyCardInviteCodeResponseDto;
};


export type MutationAddMortgageAddressArgs = {
  addMortgageAddressRequestDto: CreateMortgageAddressRequestDto;
};


export type MutationAddMortgageLeadArgs = {
  addMortgageLeadInput: AddMortgageLeadInput;
};


export type MutationAddNotificationDeviceArgs = {
  input: AddNotificationDeviceInput;
};


export type MutationAddPaymentCardToApplePayByDevicePushProvisioningArgs = {
  input: ApplePayPushProvisioningRequestDto;
};


export type MutationApplyForCreditCardProductArgs = {
  applyForCreditCardProduct: ApplyForCreditCardProductRequestDto;
};


export type MutationCancelScheduledTransferArgs = {
  scheduledTransferId: Scalars['String']['input'];
};


export type MutationCloseLinkedExternalBankAccountV2Args = {
  highnoteExternalAccountId?: InputMaybe<Scalars['String']['input']>;
  plaidAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompletePlaidLinkArgs = {
  linkSuccessInput: LinkSuccessInput;
};


export type MutationConnectHighnoteAccountHolderToPlaidArgs = {
  linkSuccessInputDto: LinkSuccessInputDto;
};


export type MutationCreateMagicLinkToLogIntoRedemptionPortalArgs = {
  redirectPath: Scalars['String']['input'];
};


export type MutationCreateMesaHomeDocumentUploadLinkArgs = {
  fileName: Scalars['String']['input'];
  mesaHomeMonthlyAwardId: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateNewMonthlyAwardArgs = {
  awardAmountInPoints: Scalars['Float']['input'];
};


export type MutationCreateOneTimePaymentV2Args = {
  consentTimestamp: Scalars['String']['input'];
  highnoteExternalAccountId: Scalars['String']['input'];
  paymentAmount: Scalars['String']['input'];
  transferDate: Scalars['String']['input'];
};


export type MutationCreateRecurringPaymentV2Args = {
  consentTimestamp: Scalars['String']['input'];
  highnoteExternalAccountId: Scalars['String']['input'];
  transferAmountStrategy: TransferBalanceAmountCode;
  transferDayOfMonth: Scalars['Int']['input'];
};


export type MutationEnrollInBenefitArgs = {
  enrollInBenefit: EnrollInBenefitInput;
};


export type MutationEnrollInMesaHomeArgs = {
  itemId: Scalars['String']['input'];
};


export type MutationGenerateStatementPdfLinkArgs = {
  input: GenerateStatementPdfLinkRequestDto;
};


export type MutationRecordSurveyResponseArgs = {
  responseData?: InputMaybe<Scalars['JSONObject']['input']>;
  responseType: UserSurveyResponseType;
  surveyId: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};


export type MutationRedeemPointsForMortgageTransferArgs = {
  redeemPointsForMortgageTransferRequestDto: RedeemPointsForMortgageTransferRequestDto;
};


export type MutationRedeemPointsForStatementCreditArgs = {
  redeemPointsForStatementCreditRequestDto: RedeemPointsForStatementCreditRequest;
};


export type MutationRedeemPointsForStatementCreditTypedArgs = {
  redeemPointsForStatementCreditRequestDto: RedeemPointsForStatementCreditRequest;
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegenerateStatementArgs = {
  input: RegenerateStatementInput;
};


export type MutationRejectCardApplicationArgs = {
  auth0UserId: Scalars['String']['input'];
};


export type MutationRequestOtpCodeArgs = {
  requestOtpCodeDto: RequestOtpCodeRequestDto;
};


export type MutationRetargetNotificationsArgs = {
  input: NotificationTargetEventsQueryInput;
};


export type MutationRetargetNotificationsEventsByIdArgs = {
  input: RetargetNotificationEventsByIdInput;
};


export type MutationSendPhoneVerificationCodeArgs = {
  sendPhoneVerificationCodeDto: SendPhoneVerificationCodeDto;
};


export type MutationSendPhoneVerificationCodeForNewAccountArgs = {
  sendPhoneVerificationCodeDto: SendPhoneVerificationCodeDto;
};


export type MutationSetAppsFlyerIdArgs = {
  input: SetAppsFlyerIdInput;
};


export type MutationSubmitCardApplicationToHighnoteArgs = {
  auth0UserId: Scalars['String']['input'];
};


export type MutationSubmitMortgageLeadArgs = {
  submitMortgageLeadRequest: SubmitMortgageLeadRequestDto;
};


export type MutationUpdateAllNotificationsPushStatusToArgs = {
  input: UpdateAllNotificationPushStatusToInput;
};


export type MutationUpdateLatestMonthlyAwardArgs = {
  awardAmountInPoints: Scalars['Float']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateMonthlyAwardArgs = {
  awardAmount: Scalars['Float']['input'];
};


export type MutationUpdateNotificationPushStatusArgs = {
  input: UpdateNotificationPushStatusInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};


export type MutationUpdateUserAddressArgs = {
  updateUserAddress: UserAddressDto;
};


export type MutationUpdateUserInformationArgs = {
  userInformation: UserInformationDto;
};


export type MutationUpdateUserMetadataArgs = {
  updateUserMetadata: UserMetadata;
};


export type MutationValidateHighnoteAddressArgs = {
  validateAddressRequestDto: ValidateAddressRequestDto;
};


export type MutationValidateOtpCodeArgs = {
  validateOtpCode: ValidateOtpCodeRequestDto;
};


export type MutationValidatePhoneVerificationCodeArgs = {
  validatePhoneVerificationCodeDto: ValidatePhoneVerificationCodeDto;
};


export type MutationVerifyCardInviteCodeArgs = {
  verifyCardInviteCode: VerifyCardInviteCodeRequestDto;
};

export type Node = {
  __typename?: 'Node';
  financialAccount: FinancialAccount;
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  physicalCardTrackingNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  virtualCardIdForPhysicalCard?: Maybe<Scalars['String']['output']>;
};

/** The Notification Events that can be triggered in the Highnote platform. */
export enum NotificationEventName {
  AccountStatusActive = 'AccountStatusActive',
  AccountStatusClosed = 'AccountStatusClosed',
  AccountStatusPendingClosure = 'AccountStatusPendingClosure',
  AccountStatusSuspended = 'AccountStatusSuspended',
  AccountStatusUnderReview = 'AccountStatusUnderReview',
  AchExternallyInitiatedDepositFailed = 'AchExternallyInitiatedDepositFailed',
  AchExternallyInitiatedDepositProcessed = 'AchExternallyInitiatedDepositProcessed',
  AchExternallyInitiatedDepositReceived = 'AchExternallyInitiatedDepositReceived',
  AchExternallyInitiatedWithdrawalFailed = 'AchExternallyInitiatedWithdrawalFailed',
  AchExternallyInitiatedWithdrawalProcessed = 'AchExternallyInitiatedWithdrawalProcessed',
  AchExternallyInitiatedWithdrawalReceived = 'AchExternallyInitiatedWithdrawalReceived',
  AchFundsDepositCanceled = 'AchFundsDepositCanceled',
  AchFundsDepositFailed = 'AchFundsDepositFailed',
  AchFundsDepositInitiated = 'AchFundsDepositInitiated',
  AchFundsDepositProcessed = 'AchFundsDepositProcessed',
  AchFundsDepositProcessing = 'AchFundsDepositProcessing',
  AchFundsDepositReturned = 'AchFundsDepositReturned',
  AchFundsWithdrawalCanceled = 'AchFundsWithdrawalCanceled',
  AchFundsWithdrawalFailed = 'AchFundsWithdrawalFailed',
  AchFundsWithdrawalInitiated = 'AchFundsWithdrawalInitiated',
  AchFundsWithdrawalProcessed = 'AchFundsWithdrawalProcessed',
  AchFundsWithdrawalProcessing = 'AchFundsWithdrawalProcessing',
  AchFundsWithdrawalReturned = 'AchFundsWithdrawalReturned',
  AchHoldAdded = 'AchHoldAdded',
  AchHoldRemoved = 'AchHoldRemoved',
  AchRepaymentFailed = 'AchRepaymentFailed',
  AchRepaymentProcessed = 'AchRepaymentProcessed',
  AchRepaymentProcessing = 'AchRepaymentProcessing',
  AchRepaymentReturned = 'AchRepaymentReturned',
  AchSecureDepositCanceled = 'AchSecureDepositCanceled',
  AchSecureDepositFailed = 'AchSecureDepositFailed',
  AchSecureDepositInitiated = 'AchSecureDepositInitiated',
  AchSecureDepositProcessed = 'AchSecureDepositProcessed',
  AchSecureDepositProcessing = 'AchSecureDepositProcessing',
  AchSecureDepositReturned = 'AchSecureDepositReturned',
  AchTransferHoldAdded = 'AchTransferHoldAdded',
  AchTransferHoldRemoved = 'AchTransferHoldRemoved',
  AuthorizationCreated = 'AuthorizationCreated',
  AuthorizedUserCardProductApplicationApproved = 'AuthorizedUserCardProductApplicationApproved',
  AuthorizedUserCardProductApplicationClosed = 'AuthorizedUserCardProductApplicationClosed',
  AuthorizedUserCardProductApplicationDenied = 'AuthorizedUserCardProductApplicationDenied',
  AuthorizedUserCardProductApplicationDocumentUploadRequested = 'AuthorizedUserCardProductApplicationDocumentUploadRequested',
  AuthorizedUserCardProductApplicationInReview = 'AuthorizedUserCardProductApplicationInReview',
  AuthorizedUserCardProductApplicationManualReview = 'AuthorizedUserCardProductApplicationManualReview',
  AuthorizedUserCardProductApplicationUnderwritingDecisionRequested = 'AuthorizedUserCardProductApplicationUnderwritingDecisionRequested',
  BusinessAccountHolderIdentityDocumentsRequested = 'BusinessAccountHolderIdentityDocumentsRequested',
  BusinessAccountHolderIdentityUpdated = 'BusinessAccountHolderIdentityUpdated',
  BusinessAuthorizedPersonIdentityDocumentsRequested = 'BusinessAuthorizedPersonIdentityDocumentsRequested',
  BusinessAuthorizedPersonIdentityUpdated = 'BusinessAuthorizedPersonIdentityUpdated',
  BusinessUltimateBeneficialOwnerIdentityDocumentsRequested = 'BusinessUltimateBeneficialOwnerIdentityDocumentsRequested',
  BusinessUltimateBeneficialOwnerIdentityUpdated = 'BusinessUltimateBeneficialOwnerIdentityUpdated',
  CardDigitalWalletTokenActivated = 'CardDigitalWalletTokenActivated',
  CardDigitalWalletTokenSuspended = 'CardDigitalWalletTokenSuspended',
  CardDigitalWalletTokenTerminated = 'CardDigitalWalletTokenTerminated',
  CardPaymentAuthorizationDeclinedEvent = 'CardPaymentAuthorizationDeclinedEvent',
  CardPaymentAuthorizedEvent = 'CardPaymentAuthorizedEvent',
  CardPaymentAuthorizingEvent = 'CardPaymentAuthorizingEvent',
  CardPaymentCaptureDeclinedEvent = 'CardPaymentCaptureDeclinedEvent',
  CardPaymentCaptureProcessingEvent = 'CardPaymentCaptureProcessingEvent',
  CardPaymentCapturedEvent = 'CardPaymentCapturedEvent',
  CardPaymentCapturingEvent = 'CardPaymentCapturingEvent',
  CardPaymentClearedEvent = 'CardPaymentClearedEvent',
  CardPaymentClearingFailedEvent = 'CardPaymentClearingFailedEvent',
  CardPaymentDisbursedEvent = 'CardPaymentDisbursedEvent',
  CardPaymentIncrementalAuthorizationDeclinedEvent = 'CardPaymentIncrementalAuthorizationDeclinedEvent',
  CardPaymentIncrementalAuthorizedEvent = 'CardPaymentIncrementalAuthorizedEvent',
  CardPaymentPartialReversedEvent = 'CardPaymentPartialReversedEvent',
  CardPaymentPayoutEvent = 'CardPaymentPayoutEvent',
  CardPaymentReversalDeclinedEvent = 'CardPaymentReversalDeclinedEvent',
  CardPaymentReversedEvent = 'CardPaymentReversedEvent',
  CardPaymentSettledEvent = 'CardPaymentSettledEvent',
  CardPaymentVerificationDeclinedEvent = 'CardPaymentVerificationDeclinedEvent',
  CardPaymentVerificationPendingEvent = 'CardPaymentVerificationPendingEvent',
  CardPaymentVerifiedEvent = 'CardPaymentVerifiedEvent',
  CardProductApplicationApproved = 'CardProductApplicationApproved',
  CardProductApplicationClosed = 'CardProductApplicationClosed',
  CardProductApplicationCreditReportFraudAlert = 'CardProductApplicationCreditReportFraudAlert',
  CardProductApplicationCreditReportFreeze = 'CardProductApplicationCreditReportFreeze',
  CardProductApplicationDenied = 'CardProductApplicationDenied',
  CardProductApplicationDocumentUploadRequested = 'CardProductApplicationDocumentUploadRequested',
  CardProductApplicationIdentityUpdateRequested = 'CardProductApplicationIdentityUpdateRequested',
  CardProductApplicationInReview = 'CardProductApplicationInReview',
  CardProductApplicationManualReview = 'CardProductApplicationManualReview',
  CardProductApplicationOfferManagementRequested = 'CardProductApplicationOfferManagementRequested',
  CardProductApplicationUnderwritingDecisionRequested = 'CardProductApplicationUnderwritingDecisionRequested',
  CheckPaymentEventCompleted = 'CheckPaymentEventCompleted',
  CheckPaymentEventFailed = 'CheckPaymentEventFailed',
  CheckPaymentEventFundingCompleted = 'CheckPaymentEventFundingCompleted',
  CheckPaymentEventFundingDisbursed = 'CheckPaymentEventFundingDisbursed',
  CheckPaymentEventFundingPending = 'CheckPaymentEventFundingPending',
  CheckPaymentEventFundingStarted = 'CheckPaymentEventFundingStarted',
  CheckPaymentEventOnRiskHold = 'CheckPaymentEventOnRiskHold',
  CheckPaymentEventPaid = 'CheckPaymentEventPaid',
  CheckPaymentEventPendingProcessingByHighnote = 'CheckPaymentEventPendingProcessingByHighnote',
  CheckPaymentEventPendingShipment = 'CheckPaymentEventPendingShipment',
  CheckPaymentEventPrinted = 'CheckPaymentEventPrinted',
  CheckPaymentEventProcessedByHighnote = 'CheckPaymentEventProcessedByHighnote',
  CheckPaymentEventProcessingByHighnote = 'CheckPaymentEventProcessingByHighnote',
  CheckPaymentEventReversalCompleted = 'CheckPaymentEventReversalCompleted',
  CheckPaymentEventReversalInitiated = 'CheckPaymentEventReversalInitiated',
  CheckPaymentEventShipped = 'CheckPaymentEventShipped',
  CheckPaymentEventVoided = 'CheckPaymentEventVoided',
  CreditLimitChangeRequestStatusChanged = 'CreditLimitChangeRequestStatusChanged',
  DocumentUploadRequestedEvent = 'DocumentUploadRequestedEvent',
  DocumentUploadSessionCompleteEvent = 'DocumentUploadSessionCompleteEvent',
  ExternalBankAccountAdded = 'ExternalBankAccountAdded',
  ExternalBankAccountRemoved = 'ExternalBankAccountRemoved',
  FeeChargeEvent = 'FeeChargeEvent',
  FeeReversalEvent = 'FeeReversalEvent',
  FileUploadCompleteEvent = 'FileUploadCompleteEvent',
  FinancialAccountAttributeAddedChargeOff = 'FinancialAccountAttributeAddedChargeOff',
  FinancialAccountAttributeAddedClosedWithBalance = 'FinancialAccountAttributeAddedClosedWithBalance',
  FinancialAccountAttributeAddedDelinquent = 'FinancialAccountAttributeAddedDelinquent',
  FinancialAccountAttributeAddedDelinquentSuspended = 'FinancialAccountAttributeAddedDelinquentSuspended',
  FinancialAccountAttributeAddedProgramOwnerInitiatedSuspension = 'FinancialAccountAttributeAddedProgramOwnerInitiatedSuspension',
  FinancialAccountAttributeRemovedChargeOff = 'FinancialAccountAttributeRemovedChargeOff',
  FinancialAccountAttributeRemovedClosedWithBalance = 'FinancialAccountAttributeRemovedClosedWithBalance',
  FinancialAccountAttributeRemovedDelinquent = 'FinancialAccountAttributeRemovedDelinquent',
  FinancialAccountAttributeRemovedDelinquentSuspended = 'FinancialAccountAttributeRemovedDelinquentSuspended',
  FinancialAccountAttributeRemovedProgramOwnerInitiatedSuspension = 'FinancialAccountAttributeRemovedProgramOwnerInitiatedSuspension',
  FinancialAccountStatementReady = 'FinancialAccountStatementReady',
  InstantNetworkTransferCompletedEvent = 'InstantNetworkTransferCompletedEvent',
  InstantNetworkTransferFailedEvent = 'InstantNetworkTransferFailedEvent',
  InstantNetworkTransferInitiatedEvent = 'InstantNetworkTransferInitiatedEvent',
  InternalTransferBetweenFinancialAccountsCompleted = 'InternalTransferBetweenFinancialAccountsCompleted',
  InternalTransferBetweenFinancialAccountsFailed = 'InternalTransferBetweenFinancialAccountsFailed',
  InternalTransferBetweenFinancialAccountsPending = 'InternalTransferBetweenFinancialAccountsPending',
  InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompleted = 'InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompleted',
  InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailed = 'InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailed',
  InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPending = 'InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPending',
  InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompleted = 'InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompleted',
  InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailed = 'InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailed',
  InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPending = 'InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPending',
  LinkVerifiedExternalBankAccountFailed = 'LinkVerifiedExternalBankAccountFailed',
  NonOriginatedAchTransferFailed = 'NonOriginatedAchTransferFailed',
  NonOriginatedAchTransferProcessed = 'NonOriginatedAchTransferProcessed',
  NonOriginatedAchTransferReceived = 'NonOriginatedAchTransferReceived',
  NonOriginatedAchTransferReturned = 'NonOriginatedAchTransferReturned',
  NotificationActivation = 'NotificationActivation',
  OriginatedAchTransferCanceled = 'OriginatedAchTransferCanceled',
  OriginatedAchTransferFailed = 'OriginatedAchTransferFailed',
  OriginatedAchTransferInitiated = 'OriginatedAchTransferInitiated',
  OriginatedAchTransferPending = 'OriginatedAchTransferPending',
  OriginatedAchTransferProcessed = 'OriginatedAchTransferProcessed',
  OriginatedAchTransferProcessing = 'OriginatedAchTransferProcessing',
  OriginatedAchTransferReturned = 'OriginatedAchTransferReturned',
  PaymentCardActivated = 'PaymentCardActivated',
  PaymentCardAdjustment = 'PaymentCardAdjustment',
  PaymentCardAuthorizationAndClearApproved = 'PaymentCardAuthorizationAndClearApproved',
  PaymentCardAuthorizationAndClearDeclined = 'PaymentCardAuthorizationAndClearDeclined',
  PaymentCardAuthorizationApproved = 'PaymentCardAuthorizationApproved',
  PaymentCardAuthorizationCreated = 'PaymentCardAuthorizationCreated',
  PaymentCardAuthorizationDeclined = 'PaymentCardAuthorizationDeclined',
  PaymentCardAuthorizationReversed = 'PaymentCardAuthorizationReversed',
  PaymentCardCleared = 'PaymentCardCleared',
  PaymentCardClosed = 'PaymentCardClosed',
  PaymentCardEnhancedDataReceived = 'PaymentCardEnhancedDataReceived',
  PaymentCardIssued = 'PaymentCardIssued',
  PaymentCardSuspended = 'PaymentCardSuspended',
  PaymentCardTransactionChargebackProvisionalCreditIssued = 'PaymentCardTransactionChargebackProvisionalCreditIssued',
  PaymentCardTransactionChargebackProvisionalCreditRevoked = 'PaymentCardTransactionChargebackProvisionalCreditRevoked',
  PaymentCardTransactionDisputeCaseStatusCancelled = 'PaymentCardTransactionDisputeCaseStatusCancelled',
  PaymentCardTransactionDisputeCaseStatusCaseCardholderLost = 'PaymentCardTransactionDisputeCaseStatusCaseCardholderLost',
  PaymentCardTransactionDisputeCaseStatusCaseCardholderWon = 'PaymentCardTransactionDisputeCaseStatusCaseCardholderWon',
  PaymentCardTransactionDisputeCaseStatusInitiated = 'PaymentCardTransactionDisputeCaseStatusInitiated',
  PaymentCardTransactionDisputeCaseStatusRejected = 'PaymentCardTransactionDisputeCaseStatusRejected',
  PaymentCardTransactionDisputeCaseStatusResolvedWithDisputeCredit = 'PaymentCardTransactionDisputeCaseStatusResolvedWithDisputeCredit',
  PaymentCardTransactionDisputeCreditIssued = 'PaymentCardTransactionDisputeCreditIssued',
  PaymentCardTransactionDisputeCreditReversed = 'PaymentCardTransactionDisputeCreditReversed',
  PaymentCardTransactionDisputeProvisionalCreditIssued = 'PaymentCardTransactionDisputeProvisionalCreditIssued',
  PaymentCardTransactionDisputeProvisionalCreditRevoked = 'PaymentCardTransactionDisputeProvisionalCreditRevoked',
  PaymentCardTransactionDisputeProvisionalCreditWon = 'PaymentCardTransactionDisputeProvisionalCreditWon',
  PaymentCardUnsuspended = 'PaymentCardUnsuspended',
  PaymentCardVerificationApproved = 'PaymentCardVerificationApproved',
  PaymentCardVerificationDeclined = 'PaymentCardVerificationDeclined',
  PayoutTransferCompletedEvent = 'PayoutTransferCompletedEvent',
  PayrollAdvanceRepaymentCompleted = 'PayrollAdvanceRepaymentCompleted',
  PayrollAdvanceWriteOffCompleted = 'PayrollAdvanceWriteOffCompleted',
  PersonAccountHolderIdentityDocumentsRequested = 'PersonAccountHolderIdentityDocumentsRequested',
  PersonAccountHolderIdentityUpdated = 'PersonAccountHolderIdentityUpdated',
  PhysicalPaymentCardGroupOrderShipFailed = 'PhysicalPaymentCardGroupOrderShipFailed',
  PhysicalPaymentCardGroupOrderShipped = 'PhysicalPaymentCardGroupOrderShipped',
  PhysicalPaymentCardShipFailed = 'PhysicalPaymentCardShipFailed',
  PhysicalPaymentCardShipped = 'PhysicalPaymentCardShipped',
  ProvisionAccountHolderCompleted = 'ProvisionAccountHolderCompleted',
  ProvisionAccountHolderCreateApplicationCompleted = 'ProvisionAccountHolderCreateApplicationCompleted',
  ProvisionAccountHolderCreateApplicationError = 'ProvisionAccountHolderCreateApplicationError',
  ProvisionAccountHolderCreateApplicationInProgress = 'ProvisionAccountHolderCreateApplicationInProgress',
  ProvisionAccountHolderCreateApplicationInitiated = 'ProvisionAccountHolderCreateApplicationInitiated',
  ProvisionAccountHolderCreateApplicationNotCompleted = 'ProvisionAccountHolderCreateApplicationNotCompleted',
  ProvisionAccountHolderError = 'ProvisionAccountHolderError',
  ProvisionAccountHolderInProgress = 'ProvisionAccountHolderInProgress',
  ProvisionAccountHolderInitiated = 'ProvisionAccountHolderInitiated',
  ProvisionAccountHolderIssueFinancialAccountCompleted = 'ProvisionAccountHolderIssueFinancialAccountCompleted',
  ProvisionAccountHolderIssueFinancialAccountError = 'ProvisionAccountHolderIssueFinancialAccountError',
  ProvisionAccountHolderIssueFinancialAccountInProgress = 'ProvisionAccountHolderIssueFinancialAccountInProgress',
  ProvisionAccountHolderIssueFinancialAccountInitiated = 'ProvisionAccountHolderIssueFinancialAccountInitiated',
  ProvisionAccountHolderIssueFinancialAccountNotCompleted = 'ProvisionAccountHolderIssueFinancialAccountNotCompleted',
  ProvisionAccountHolderIssuePaymentCardCompleted = 'ProvisionAccountHolderIssuePaymentCardCompleted',
  ProvisionAccountHolderIssuePaymentCardError = 'ProvisionAccountHolderIssuePaymentCardError',
  ProvisionAccountHolderIssuePaymentCardInProgress = 'ProvisionAccountHolderIssuePaymentCardInProgress',
  ProvisionAccountHolderIssuePaymentCardInitiated = 'ProvisionAccountHolderIssuePaymentCardInitiated',
  ProvisionAccountHolderIssuePaymentCardNotCompleted = 'ProvisionAccountHolderIssuePaymentCardNotCompleted',
  ProvisionAccountHolderLinkExternalBankAccountCompleted = 'ProvisionAccountHolderLinkExternalBankAccountCompleted',
  ProvisionAccountHolderLinkExternalBankAccountError = 'ProvisionAccountHolderLinkExternalBankAccountError',
  ProvisionAccountHolderLinkExternalBankAccountInProgress = 'ProvisionAccountHolderLinkExternalBankAccountInProgress',
  ProvisionAccountHolderLinkExternalBankAccountInitiated = 'ProvisionAccountHolderLinkExternalBankAccountInitiated',
  ProvisionAccountHolderLinkExternalBankAccountNotCompleted = 'ProvisionAccountHolderLinkExternalBankAccountNotCompleted',
  ProvisionAccountHolderNotifyProviderCompleted = 'ProvisionAccountHolderNotifyProviderCompleted',
  ProvisionAccountHolderNotifyProviderError = 'ProvisionAccountHolderNotifyProviderError',
  ProvisionAccountHolderNotifyProviderInProgress = 'ProvisionAccountHolderNotifyProviderInProgress',
  ProvisionAccountHolderNotifyProviderInitiated = 'ProvisionAccountHolderNotifyProviderInitiated',
  ProvisionAccountHolderNotifyProviderNotCompleted = 'ProvisionAccountHolderNotifyProviderNotCompleted',
  ProvisionAccountHolderRegisterVisaPayableFundingAccountCompleted = 'ProvisionAccountHolderRegisterVisaPayableFundingAccountCompleted',
  ProvisionAccountHolderRegisterVisaPayableFundingAccountError = 'ProvisionAccountHolderRegisterVisaPayableFundingAccountError',
  ProvisionAccountHolderRegisterVisaPayableFundingAccountInProgress = 'ProvisionAccountHolderRegisterVisaPayableFundingAccountInProgress',
  ProvisionAccountHolderRegisterVisaPayableFundingAccountInitiated = 'ProvisionAccountHolderRegisterVisaPayableFundingAccountInitiated',
  ProvisionAccountHolderRegisterVisaPayableFundingAccountNotCompleted = 'ProvisionAccountHolderRegisterVisaPayableFundingAccountNotCompleted',
  ProvisionAccountHolderRejected = 'ProvisionAccountHolderRejected',
  ProvisionAccountHolderSetCreditLimitCompleted = 'ProvisionAccountHolderSetCreditLimitCompleted',
  ProvisionAccountHolderSetCreditLimitError = 'ProvisionAccountHolderSetCreditLimitError',
  ProvisionAccountHolderSetCreditLimitInProgress = 'ProvisionAccountHolderSetCreditLimitInProgress',
  ProvisionAccountHolderSetCreditLimitInitiated = 'ProvisionAccountHolderSetCreditLimitInitiated',
  ProvisionAccountHolderSetCreditLimitNotCompleted = 'ProvisionAccountHolderSetCreditLimitNotCompleted',
  ReportCompleted = 'ReportCompleted',
  ReportFailed = 'ReportFailed',
  UnifiedFundsTransferCompletedEvent = 'UnifiedFundsTransferCompletedEvent',
  UnifiedFundsTransferFailedEvent = 'UnifiedFundsTransferFailedEvent',
  UnifiedFundsTransferInitiatedEvent = 'UnifiedFundsTransferInitiatedEvent',
  UpcomingStatementDueDate = 'UpcomingStatementDueDate'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  announcements: AnnouncementsCategory;
  card: CardCategory;
  marketing: MarketingCategory;
};

export type NotificationTargetEventsQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<WebhookNotificationTargetEventFilterInputClass>;
  first?: InputMaybe<Scalars['Float']['input']>;
  source: Scalars['String']['input'];
};

export type NotificationTimestampFilterInputClass = {
  between?: InputMaybe<NotificationTimestampFilterInputRangeClass>;
  equals?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEquals?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEquals?: InputMaybe<Scalars['String']['input']>;
  notEquals?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTimestampFilterInputRangeClass = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type Notifications = {
  __typename?: 'Notifications';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deepLinkPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pushNotificationStatus: UserPushNotificationStatus;
  title: Scalars['String']['output'];
};

export type OneTimeAchTransferResponse = {
  __typename?: 'OneTimeAchTransferResponse';
  fromHighnoteExternalAccount?: Maybe<HighnoteExternalAccountResponse>;
  id: Scalars['String']['output'];
  scheduledTransferDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ScheduledTransferStatusCode>;
  transferAmount?: Maybe<TransferAmountResponse>;
};

export type OpenLoyaltyMemberInfoLabel = {
  __typename?: 'OpenLoyaltyMemberInfoLabel';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OpenLoyaltyMemberInfoLabels = {
  __typename?: 'OpenLoyaltyMemberInfoLabels';
  labels: Array<OpenLoyaltyMemberInfoLabel>;
};

export type PlaidAccountResponse = {
  __typename?: 'PlaidAccountResponse';
  accountName: Scalars['String']['output'];
  bankAccountLast4: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  plaidAccountId: Scalars['ID']['output'];
};

export enum PlaidItemStatus {
  Healthy = 'HEALTHY',
  UpdateRequired = 'UPDATE_REQUIRED'
}

export type PointsBalance = {
  __typename?: 'PointsBalance';
  value: Scalars['Int']['output'];
};

export type PointsBalanceResponse = {
  __typename?: 'PointsBalanceResponse';
  active: PointsBalance;
  lifetimeEarned: PointsBalance;
  lifetimeSpent: PointsBalance;
  pending: PointsBalance;
  /** @deprecated Use `active` instead */
  value: Scalars['Int']['output'];
};

export type PointsEarnResponse = {
  __typename?: 'PointsEarnResponse';
  points: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
};

export type PointsLedgerAmount = {
  __typename?: 'PointsLedgerAmount';
  decimalPlaces: Scalars['Int']['output'];
  isNegative: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type PointsLedgerItem = {
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type PointsLedgerPage = {
  __typename?: 'PointsLedgerPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PointsLedgerItem>;
  nextCursor: Scalars['String']['output'];
};

export type ProductEnrollmentModel = {
  __typename?: 'ProductEnrollmentModel';
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  isEnrolled: Scalars['Boolean']['output'];
};

export enum Products {
  Assets = 'Assets',
  Auth = 'Auth',
  Balance = 'Balance',
  BalancePlus = 'BalancePlus',
  Beacon = 'Beacon',
  CraBaseReport = 'CraBaseReport',
  CraCashflowInsights = 'CraCashflowInsights',
  CraIncomeInsights = 'CraIncomeInsights',
  CraMonitoring = 'CraMonitoring',
  CraNetworkInsights = 'CraNetworkInsights',
  CraPartnerInsights = 'CraPartnerInsights',
  CreditDetails = 'CreditDetails',
  Employment = 'Employment',
  Identity = 'Identity',
  IdentityMatch = 'IdentityMatch',
  IdentityVerification = 'IdentityVerification',
  Income = 'Income',
  IncomeVerification = 'IncomeVerification',
  Investments = 'Investments',
  InvestmentsAuth = 'InvestmentsAuth',
  Layer = 'Layer',
  Liabilities = 'Liabilities',
  PayByBank = 'PayByBank',
  PaymentInitiation = 'PaymentInitiation',
  ProcessorIdentity = 'ProcessorIdentity',
  ProcessorPayments = 'ProcessorPayments',
  Profile = 'Profile',
  ProtectLinkedBank = 'ProtectLinkedBank',
  RecurringTransactions = 'RecurringTransactions',
  Signal = 'Signal',
  StandingOrders = 'StandingOrders',
  Statements = 'Statements',
  Transactions = 'Transactions',
  TransactionsRefresh = 'TransactionsRefresh',
  Transfer = 'Transfer'
}

export type PromoCodeBonusPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'PromoCodeBonusPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
  promoCode?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  availableSurveys: AvailableSurveys;
  cardActivityFeed: CardActivityFeedResponse;
  checkPhoneNumberIsAvailable: CheckPhoneNumberIsAvailableResponse;
  generateDocumentUploadClientToken: HighnoteDocumentUploadClientToken;
  generateLinkToken: CreateLinkTokenResponse;
  geoLookup: GeoLookupResultModel;
  getApplicationSubmissionScreen: ApplicationSubmissionScreen;
  getBenefitEnrollments: OpenLoyaltyMemberInfoLabels;
  getBenefitStatementCreditsByBenefitId: GetBenefitStatementCreditsByBenefitIdResponse;
  getBenefits: GetBenefitsResponse;
  getCardOrderInformation: FindCardOrderResponse;
  getCardProductApplicationStatus: IGetCardProductApplicationStatusObjectType;
  getCashForMortgageRedemptionMetrics: CashForMortgageRedemptionMetricsResponse;
  getCreditCardInformation: FindPaymentCardResponse;
  getCreditLineInformation: IGetAccountHolderCardProductApplicationObjectType;
  getLatestMonthlyAward: MesaHomeMonthlyAward;
  getLatestOneTimeScheduledPayment: FindSchedulePaymentResponse;
  /** WARNING: This endpoint's name is misleading. It returns all plaid accounts (given the parameterized `products` filter), including those which can be not externally linked (e.g. to Highnote) or not verified yet */
  getLinkedExternalBankAccounts: GetLinkedExternalAccountsResponse;
  getMemberBenefitEnrollments: GetMemberBenefitEnrollmentsResponse;
  getMortgageAddresses: GetMortgageAddressesResponseDto;
  getMortgageLeads: Array<MortgageLeadModel>;
  getMyLowesRewardsStatus: GetMyLowesRewardsStatusResponse;
  getNewestMortgageLead?: Maybe<GetNewestMortgageLeadResponse>;
  getNotificationSettings: GetNotificationSettingsResponse;
  getPointsBalance: PointsBalanceResponse;
  getPointsLedgerPage: PointsLedgerPage;
  getRecurringScheduledPayment: FindSchedulePaymentResponse;
  getReferralBonusOfferEligibility: GetReferralBonusOfferEligibilityResponse;
  getReferralStats: ReferralProductsStatsForReferrerResponse;
  getStatements: Array<Statement>;
  getUserInfo: GetUserInfoResponse;
  getUserNotifications: GetUserNotificationsResponse;
  getWaitlistStatus: GetWaitlistStatusResponseDto;
  helloAuthenticatedUser: Scalars['String']['output'];
  helloWorld: Scalars['String']['output'];
  incomingScheduledTransfers: IncomingScheduledTransfersResponse;
  /** @deprecated Use `linkedItems` instead */
  linkedAccounts: Array<LinkedAccountModel>;
  linkedItems: Array<LinkedItemModel>;
  mesaHomeEnrollment: MesaHomeEnrollment;
  ping: CreditCardPingResponse;
  session: SessionResult;
  transactionEventDetails: TransactionEventDetailsResponse;
  validateOfferCodeForCardApplication: ValidateOfferCodeForCardApplicationResponse;
};


export type QueryCardActivityFeedArgs = {
  cursor?: InputMaybe<CardActivityFeedCursorInput>;
  orderBy?: InputMaybe<CardActivityOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardActivityFeedWhereInput>;
};


export type QueryCheckPhoneNumberIsAvailableArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGenerateLinkTokenArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  isAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Products>>;
};


export type QueryGetBenefitStatementCreditsByBenefitIdArgs = {
  benefitId: Scalars['String']['input'];
};


export type QueryGetLinkedExternalBankAccountsArgs = {
  products?: InputMaybe<Array<Products>>;
};


export type QueryGetMortgageLeadsArgs = {
  includeInactive?: Scalars['Boolean']['input'];
  type?: InputMaybe<MortgageLeadType>;
};


export type QueryGetMyLowesRewardsStatusArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetNewestMortgageLeadArgs = {
  getNewestMortgageLeadRequest: GetNewestMortgageLeadRequestDto;
};


export type QueryGetPointsLedgerPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserNotificationsArgs = {
  cursor?: InputMaybe<UserNotificationCursorInput>;
  pushNotificationStatus?: InputMaybe<UserPushNotificationStatus>;
};


export type QueryTransactionEventDetailsArgs = {
  transactionEventId: Scalars['String']['input'];
};


export type QueryValidateOfferCodeForCardApplicationArgs = {
  offerCode?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringAchTransferResponse = {
  __typename?: 'RecurringAchTransferResponse';
  fromHighnoteExternalAccount?: Maybe<HighnoteExternalAccountResponse>;
  id: Scalars['String']['output'];
  nextScheduledTransferDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ScheduledTransferStatusCode>;
  transferAmount?: Maybe<TransferAmountResponse>;
};

export type RedeemPointsForMortgageTransferRequestDto = {
  idempotencyKey: Scalars['String']['input'];
  mortgageAddressId?: InputMaybe<Scalars['String']['input']>;
  numPoints: Scalars['Int']['input'];
  plaidAccountId: Scalars['String']['input'];
};

export type RedeemPointsForMortgageTransferResponsDto = {
  __typename?: 'RedeemPointsForMortgageTransferResponsDto';
  amountCents: Scalars['Float']['output'];
  plaidTransferAuthorizationId: Scalars['String']['output'];
  points: Scalars['Float']['output'];
};

export type RedeemPointsForStatementCreditRequest = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  numPoints: Scalars['Int']['input'];
};

export type RedeemPointsForStatementCreditResult = MesaGenericOk | MesaUserError;

export type RedemptionPortalLoginLinkResponse = {
  __typename?: 'RedemptionPortalLoginLinkResponse';
  loginLink: Scalars['String']['output'];
};

export type ReferralBonusPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'ReferralBonusPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type ReferralProductStatsForReferrer = {
  __typename?: 'ReferralProductStatsForReferrer';
  numberOfReferredMembers: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
};

export type ReferralProductsStatsForReferrerResponse = {
  __typename?: 'ReferralProductsStatsForReferrerResponse';
  CARD: ReferralProductStatsForReferrer;
};

export type RegenerateStatementInput = {
  financialAccountId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type RenderedAmountResponse = {
  __typename?: 'RenderedAmountResponse';
  amount: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
};

export type RequestOtpCodeRequestDto = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type RequestOtpCodeResponseDto = {
  __typename?: 'RequestOtpCodeResponseDto';
  requested: Scalars['Boolean']['output'];
};

export type RetargetNotificationEventsByIdInput = {
  notificationEventIds: Array<Scalars['String']['input']>;
  targetIds: Array<Scalars['String']['input']>;
};

export enum ScheduledTransferStatusCode {
  Active = 'Active',
  Canceled = 'Canceled',
  Closed = 'Closed',
  Scheduled = 'Scheduled'
}

export type SendPhoneVerificationCodeDto = {
  phoneNumber: Scalars['String']['input'];
};

export type SendPhoneVerificationCodeError = {
  __typename?: 'SendPhoneVerificationCodeError';
  message: Scalars['String']['output'];
};

export type SendPhoneVerificationCodeResponse = {
  __typename?: 'SendPhoneVerificationCodeResponse';
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendPhoneVerificationCodeResult = SendPhoneVerificationCodeError | SendPhoneVerificationCodeSuccess;

export type SendPhoneVerificationCodeSuccess = {
  __typename?: 'SendPhoneVerificationCodeSuccess';
  /**
   * Taken from [Twilio's verification API](https://github.com/twilio/twilio-node/blob/cb066486213cb74bf87b271748aa388035f2fffc/src/rest/verify/v2/service/verification.ts#L281-L284):
   *
   * > The status of the verification. Can be: `pending`, `approved`, `canceled`, `max_attempts_reached`, `deleted`, `failed` or `expired`.
   */
  status?: Maybe<Scalars['String']['output']>;
};

export type SessionResult = {
  __typename?: 'SessionResult';
  sessionKey: Scalars['String']['output'];
};

export type SetAppsFlyerIdInput = {
  appsFlyerId: Scalars['String']['input'];
};

export type SetAppsFlyerIdResponse = MesaGenericOk | MesaUserError;

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Statement = {
  __typename?: 'Statement';
  isStatementPdfAvailable: Scalars['Boolean']['output'];
  statementDate: Scalars['DateTime']['output'];
  statementId: Scalars['String']['output'];
};

export type StatementCreditRedemptionPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'StatementCreditRedemptionPointsLedgerItem';
  amount: PointsLedgerAmount;
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

/** Possible types for a statement credit */
export enum StatementCreditType {
  BenefitsPartner = 'BENEFITS_PARTNER',
  CreditReturn = 'CREDIT_RETURN',
  PointsRedemption = 'POINTS_REDEMPTION'
}

export type StatementCreditWhereInput = {
  highnoteFinancialAccountTransferStatus?: InputMaybe<EnumInterFinancialAccountTransferStatusNullableFilter>;
};

export type StringNullableFilterInput = {
  equals?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitMortgageLeadRequestDto = {
  loanPurpose: Scalars['String']['input'];
};

export type SubmitMortgageLeadResponse = {
  __typename?: 'SubmitMortgageLeadResponse';
  status: Scalars['String']['output'];
};

export type SunsetFlushPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'SunsetFlushPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type Survey = {
  __typename?: 'Survey';
  id: Scalars['String']['output'];
};

export type SynchronousApplicationSubmissionResult = {
  __typename?: 'SynchronousApplicationSubmissionResult';
  screen: ApplicationSubmissionScreen;
};

export type TransactionEventDetailsResponse = {
  __typename?: 'TransactionEventDetailsResponse';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  merchantDetails?: Maybe<MerchantDetailsResponse>;
  pointsEarns?: Maybe<Array<PointsEarnResponse>>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  renderedAmount: RenderedAmountResponse;
  transactionProcessingType: CardTransactionProcessingType;
  type: TransactionEventType;
};

export type TransactionEventPointsEarn = {
  __typename?: 'TransactionEventPointsEarn';
  pending: Scalars['Boolean']['output'];
  points: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export enum TransactionEventType {
  PaymentCardAuthorizationAndClearApprovedEvent = 'PaymentCardAuthorizationAndClearApprovedEvent',
  PaymentCardAuthorizationAndClearDeclinedEvent = 'PaymentCardAuthorizationAndClearDeclinedEvent',
  PaymentCardAuthorizationApprovedEvent = 'PaymentCardAuthorizationApprovedEvent',
  PaymentCardAuthorizationDeclinedEvent = 'PaymentCardAuthorizationDeclinedEvent',
  PaymentCardAuthorizationReversedEvent = 'PaymentCardAuthorizationReversedEvent',
  PaymentCardClearedEvent = 'PaymentCardClearedEvent',
  PaymentCardVerificationApprovedEvent = 'PaymentCardVerificationApprovedEvent',
  PaymentCardVerificationDeclinedEvent = 'PaymentCardVerificationDeclinedEvent'
}

export type TransferAmountCalculationResponse = {
  __typename?: 'TransferAmountCalculationResponse';
  calculatedType: CalculatedTransferAmountType;
};

export type TransferAmountResponse = ManualTransferAmountResponse | TransferAmountCalculationResponse;

export enum TransferBalanceAmountCode {
  MinimumPayment = 'MinimumPayment',
  OutstandingBalance = 'OutstandingBalance',
  OutstandingStatementBalance = 'OutstandingStatementBalance'
}

/** Possible statuses for a transfers */
export enum TransferStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Returned = 'RETURNED'
}

export type UnknownEarnPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'UnknownEarnPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type UnknownSpendPointsLedgerItem = PointsLedgerItem & {
  __typename?: 'UnknownSpendPointsLedgerItem';
  canViewDetails: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPending: Scalars['Boolean']['output'];
  points: PointsLedgerAmount;
};

export type UpdateAllNotificationPushStatusToInput = {
  pushNotificationStatus: UserPushNotificationStatus;
};

export type UpdateAllNotificationPushStatusToResponse = MesaGenericOk | MesaUserError;

export type UpdateAwardResult = {
  __typename?: 'UpdateAwardResult';
  awardAmount: Scalars['Float']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateMesaHomeMonthlyAward = {
  __typename?: 'UpdateMesaHomeMonthlyAward';
  awardAmountInPoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  source?: Maybe<MesaHomeMonthlyAwardSource>;
};

export type UpdateNotificationPushStatusInput = {
  id: Scalars['String']['input'];
  pushNotificationStatus: UserPushNotificationStatus;
};

export type UpdateNotificationPushStatusResponse = MesaGenericOk | MesaUserError;

export type UpdateNotificationSettingsInput = {
  settings: Scalars['JSONObject']['input'];
};

export type UpdateNotificationSettingsResponse = MesaGenericOk | MesaUserError;

export type UploadedDocument = {
  __typename?: 'UploadedDocument';
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type UserAddressDto = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserInformationDto = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sourcePartnerName?: InputMaybe<Scalars['String']['input']>;
};

export type UserMetadata = {
  userTrackingFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserMetadataResponse = {
  __typename?: 'UserMetadataResponse';
  userTrackingFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserNotificationCursorInput = {
  id: Scalars['String']['input'];
};

export enum UserPushNotificationStatus {
  Created = 'CREATED',
  Opened = 'OPENED',
  Received = 'RECEIVED',
  Viewed = 'VIEWED'
}

export enum UserSurveyResponseType {
  CompletedSurvey = 'COMPLETED_SURVEY',
  DismissedSurvey = 'DISMISSED_SURVEY'
}

export type ValidateAddressRequestDto = {
  extendedAddress?: InputMaybe<Scalars['String']['input']>;
  locality: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type ValidateAddressResponseDto = {
  __typename?: 'ValidateAddressResponseDto';
  addressValidationOutcome?: Maybe<Scalars['String']['output']>;
  standarizedExtendedAddress?: Maybe<Scalars['String']['output']>;
  standarizedLocality?: Maybe<Scalars['String']['output']>;
  standarizedPostalCode?: Maybe<Scalars['String']['output']>;
  standarizedRegion?: Maybe<Scalars['String']['output']>;
  standarizedStreetAddress?: Maybe<Scalars['String']['output']>;
};

export type ValidateOfferCodeForCardApplicationResponse = {
  __typename?: 'ValidateOfferCodeForCardApplicationResponse';
  isValid: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
};

export type ValidateOtpCodeRequestDto = {
  email?: InputMaybe<Scalars['String']['input']>;
  otpCode: Scalars['String']['input'];
};

export type ValidatePhoneVerificationCodeDto = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ValidatePhoneVerificationCodeResponse = {
  __typename?: 'ValidatePhoneVerificationCodeResponse';
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type VerifyCardInviteCodeRequestDto = {
  inviteCode: Scalars['String']['input'];
};

export type VerifyCardInviteCodeResponseDto = {
  __typename?: 'VerifyCardInviteCodeResponseDto';
  verificationCodeType?: Maybe<Scalars['String']['output']>;
  verificationSuccessful: Scalars['Boolean']['output'];
};

export type WebhookNotificationTargetEventFilterInputClass = {
  eventCreatedAt?: InputMaybe<NotificationTimestampFilterInputClass>;
  hasSuccessfulDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Array<NotificationEventName>>;
};

export type GenerateClientTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateClientTokenMutation = { __typename?: 'Mutation', generateClientToken: { __typename?: 'HighnoteClientToken', clientToken: string } };

export type GetUnreadNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationsQuery = { __typename?: 'Query', getUserNotifications: { __typename: 'GetUserNotificationsResponse', notifications: Array<{ __typename: 'Notifications', id: string }> } };

export type RefreshAccessTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'BaseAuthTokenResponseDto', accessToken: string, tokenType: string, expiresIn: number } };

export type JoinWaitlistMutationVariables = Exact<{ [key: string]: never; }>;


export type JoinWaitlistMutation = { __typename?: 'Mutation', joinWaitlist: { __typename?: 'JoinWaitlistResponseDto', status: JoinWaitlistResponseStatus, message: string } };

export type VerifyCardInviteCodeMutationVariables = Exact<{
  verifyCardInviteCode: VerifyCardInviteCodeRequestDto;
}>;


export type VerifyCardInviteCodeMutation = { __typename?: 'Mutation', verifyCardInviteCode: { __typename?: 'VerifyCardInviteCodeResponseDto', verificationSuccessful: boolean, verificationCodeType?: string | null } };

export type GenerateStatementPdfLinkMutationVariables = Exact<{
  statementId: Scalars['String']['input'];
}>;


export type GenerateStatementPdfLinkMutation = { __typename?: 'Mutation', generateStatementPdfLink: { __typename?: 'GenerateStatementPdfLinkResponseDto', url: string } };

export type ActivatePaymentCardMutationVariables = Exact<{ [key: string]: never; }>;


export type ActivatePaymentCardMutation = { __typename?: 'Mutation', activatePaymentCard: boolean };

export type RedeemPointsForStatementCreditMutationVariables = Exact<{
  numPoints: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
}>;


export type RedeemPointsForStatementCreditMutation = { __typename?: 'Mutation', redeemPointsForStatementCredit: boolean };

export type AddPaymentCardToApplePayByDevicePushProvisioningMutationVariables = Exact<{
  input: ApplePayPushProvisioningRequestDto;
}>;


export type AddPaymentCardToApplePayByDevicePushProvisioningMutation = { __typename?: 'Mutation', addPaymentCardToApplePayByDevicePushProvisioning: { __typename?: 'ApplePayPushProvisioningResponseDto', encryptedPassData: string, activationData: string, ephemeralPublicKey: string } };

export type CompletePlaidLinkMutationVariables = Exact<{
  input: LinkSuccessInput;
}>;


export type CompletePlaidLinkMutation = { __typename?: 'Mutation', completePlaidLink: { __typename?: 'LinkResultModel', status: LinkResultStatus } };

export type RequestOtpCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestOtpCodeMutation = { __typename?: 'Mutation', requestOTPCode: { __typename?: 'RequestOtpCodeResponseDto', requested: boolean } };

export type ValidateOtpCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
}>;


export type ValidateOtpCodeMutation = { __typename?: 'Mutation', validateOtpCode: { __typename?: 'AuthTokenResponseDTO', accessToken: string, tokenType: string, expiresIn: number, refreshToken: string } };

export type UpdateUserInformationMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sourcePartnerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserInformationMutation = { __typename?: 'Mutation', updateUserInformation: { __typename?: 'GetUserInfoResponse', id: string, name?: string | null, nickname?: string | null, phoneNumber?: string | null, picture?: string | null, lastLogin?: string | null, createdAt: string, updatedAt: string, firstName?: string | null, lastName?: string | null, email: string, sourcePartnerName?: string | null, metadata?: { __typename?: 'UserMetadataResponse', userTrackingFlag?: boolean | null } | null, cardInformation?: { __typename?: 'CreditCardResponse', lastFour?: string | null } | null } };

export type SendPhoneVerificationCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type SendPhoneVerificationCodeMutation = { __typename?: 'Mutation', sendPhoneVerificationCode: { __typename?: 'SendPhoneVerificationCodeResponse', success: boolean, status: string } };

export type SendPhoneVerificationCodeForNewAccountMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type SendPhoneVerificationCodeForNewAccountMutation = { __typename?: 'Mutation', sendPhoneVerificationCodeForNewAccount: { __typename: 'SendPhoneVerificationCodeError', message: string } | { __typename: 'SendPhoneVerificationCodeSuccess' } };

export type ValidatePhoneVerificationCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ValidatePhoneVerificationCodeMutation = { __typename?: 'Mutation', validatePhoneVerificationCode: { __typename?: 'ValidatePhoneVerificationCodeResponse', success: boolean, status: string } };

export type UpdateUserAddressMutationVariables = Exact<{
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}>;


export type UpdateUserAddressMutation = { __typename?: 'Mutation', updateUserAddress: boolean };

export type ValidateAndUpdateHighnoteAddressMutationVariables = Exact<{
  streetAddress: Scalars['String']['input'];
  extendedAddress?: InputMaybe<Scalars['String']['input']>;
  locality: Scalars['String']['input'];
  region: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}>;


export type ValidateAndUpdateHighnoteAddressMutation = { __typename?: 'Mutation', validateHighnoteAddress: { __typename?: 'ValidateAddressResponseDto', addressValidationOutcome?: string | null, standarizedStreetAddress?: string | null, standarizedExtendedAddress?: string | null, standarizedRegion?: string | null, standarizedLocality?: string | null, standarizedPostalCode?: string | null } };

export type UpdateAppsFlyerIdMutationVariables = Exact<{
  appsFlyerId: Scalars['String']['input'];
}>;


export type UpdateAppsFlyerIdMutation = { __typename?: 'Mutation', setAppsFlyerId: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError' } };

export type GetWaitlistStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaitlistStatusQuery = { __typename?: 'Query', getWaitlistStatus: { __typename?: 'GetWaitlistStatusResponseDto', isWaitlisted: boolean } };

export type GetCreditCardInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditCardInformationQuery = { __typename?: 'Query', getCreditCardInformation: { __typename?: 'FindPaymentCardResponse', node?: { __typename?: 'Node', id: string, last4: string, status: string, virtualCardIdForPhysicalCard?: string | null, physicalCardTrackingNumber?: string | null, financialAccount: { __typename?: 'FinancialAccount', id: string, name: string, accountStatus: string, creditOutstanding: number, availableCredit: number, accountHodlerCreditLimit: number, outstandingBalancePayable: number, currentAmountDue: number, statementPaymentDueOn?: string | null, statementBalance?: string | null, statementMinimumPayment?: string | null, statementPeriodEnd?: string | null, statementPeriodStart?: string | null, paymentCardAPR?: number | null, paymentCardCreditLine?: number | null, paymentCardNextClosingDate?: string | null } } | null } };

export type GetCardOrderInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCardOrderInformationQuery = { __typename?: 'Query', getCardOrderInformation: { __typename?: 'FindCardOrderResponse', node?: { __typename?: 'CardOrderInformation', id: string, status: string, trackingNumber?: string | null } | null } };

export type GenerateDocumentUploadClientTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateDocumentUploadClientTokenQuery = { __typename?: 'Query', generateDocumentUploadClientToken: { __typename?: 'HighnoteDocumentUploadClientToken', result: { __typename: 'HighnoteDocumentUploadClientTokenSuccess', clientTokenValue: string, documentUploadSessionId: string } | { __typename: 'HighnoteDocumentUploadClientTokenUnavailable', message: string } | { __typename: 'MesaUserError', message: string } } };

export type GetLinkedExternalBankAccountsQueryVariables = Exact<{
  products?: InputMaybe<Array<Products> | Products>;
}>;


export type GetLinkedExternalBankAccountsQuery = { __typename?: 'Query', getLinkedExternalBankAccounts: { __typename?: 'GetLinkedExternalAccountsResponse', accounts: Array<{ __typename?: 'Account', highnoteExternalAccountId?: string | null, plaidAccountId?: string | null, last4: string, bankName: string, accountName: string, accountSubtype: string, isVerified: boolean, status?: PlaidItemStatus | null, products: Array<Products> }> } };

export type GetStatementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatementsQuery = { __typename?: 'Query', getStatements: Array<{ __typename?: 'Statement', statementId: string, statementDate: string }> };

export type GetMortgageLeadsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMortgageLeadsQuery = { __typename?: 'Query', getMortgageLeads: Array<{ __typename?: 'MortgageLeadModel', id: string, status: string, type: MortgageLeadType, createdAt: string }> };

export type GetMesaHomeEnrollmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMesaHomeEnrollmentQuery = { __typename?: 'Query', mesaHomeEnrollment: { __typename?: 'MesaHomeEnrollment', isEnrolled: boolean, recognizedMortgageAmount?: number | null, awardSource?: MesaHomeMonthlyAwardSource | null, canUserEditAwardAmount?: boolean | null, statementSpend?: number | null, statementSpendRemaining?: number | null, statementCloseDate?: string | null, errorDisplayMessage?: string | null } };

export type GenerateLinkTokenQueryVariables = Exact<{
  products?: InputMaybe<Array<Products> | Products>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  isAndroid?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateLinkTokenQuery = { __typename?: 'Query', generateLinkToken: { __typename?: 'CreateLinkTokenResponse', linkToken: string, expiration: string, requestId: string } };

export type GenerateLinkTokenForMortgageEarnQueryVariables = Exact<{
  isAndroid?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateLinkTokenForMortgageEarnQuery = { __typename?: 'Query', generateLinkToken: { __typename?: 'CreateLinkTokenResponse', linkToken: string, expiration: string, requestId: string } };

export type GetPlaidLinkedAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaidLinkedAccountsQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccountModel', id: string, name: string, mask: string, itemId: string, type: string, subtype: string, institutionName: string, products: Array<Products>, consentedProducts: Array<Products>, billedProducts: Array<Products>, availableProducts: Array<Products>, verificationStatus: AccountVerificationStatus, isTransactionsActive: boolean, isAuthActive: boolean }> };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', getUserInfo: { __typename?: 'GetUserInfoResponse', id: string, firstName?: string | null, lastName?: string | null, email: string, name?: string | null, nickname?: string | null, phoneNumber?: string | null, picture?: string | null, lastLogin?: string | null, createdAt: string, updatedAt: string, redeemedCardInviteCode?: string | null, referralCode?: string | null, sourcePartnerName?: string | null, metadata?: { __typename?: 'UserMetadataResponse', userTrackingFlag?: boolean | null } | null, cardInformation?: { __typename?: 'CreditCardResponse', lastFour?: string | null } | null } };

export type CheckPhoneNumberIsAvailableQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type CheckPhoneNumberIsAvailableQuery = { __typename?: 'Query', checkPhoneNumberIsAvailable: { __typename?: 'CheckPhoneNumberIsAvailableResponse', phoneNumberIsAvailable: boolean } };

export type CancelScheduledTransferMutationVariables = Exact<{
  scheduledTransferId: Scalars['String']['input'];
}>;


export type CancelScheduledTransferMutation = { __typename?: 'Mutation', cancelScheduledTransfer: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError', message: string } };

export type CloseLinkedExternalBankAccountMutationVariables = Exact<{
  highnoteExternalAccountId?: InputMaybe<Scalars['String']['input']>;
  plaidAccountId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloseLinkedExternalBankAccountMutation = { __typename?: 'Mutation', closeLinkedExternalBankAccountV2: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError', message: string } };

export type GeoLookupQueryVariables = Exact<{ [key: string]: never; }>;


export type GeoLookupQuery = { __typename?: 'Query', geoLookup: { __typename: 'GeolocationInferenceFailedModel', errorMessage: string } | { __typename: 'InferredGeolocationModel', city?: string | null, stateCode?: string | null, countryCode: string } };

export type CreateMagicLinkToLogIntoRedemptionPortalMutationVariables = Exact<{
  redirectPath: Scalars['String']['input'];
}>;


export type CreateMagicLinkToLogIntoRedemptionPortalMutation = { __typename?: 'Mutation', createMagicLinkToLogIntoRedemptionPortal: { __typename?: 'RedemptionPortalLoginLinkResponse', loginLink: string } };

export type GetPointsBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointsBalanceQuery = { __typename?: 'Query', getPointsBalance: { __typename?: 'PointsBalanceResponse', active: { __typename?: 'PointsBalance', value: number }, pending: { __typename?: 'PointsBalance', value: number }, lifetimeEarned: { __typename?: 'PointsBalance', value: number }, lifetimeSpent: { __typename?: 'PointsBalance', value: number } } };

export type GetReferralStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralStatsQuery = { __typename?: 'Query', getReferralStats: { __typename?: 'ReferralProductsStatsForReferrerResponse', CARD: { __typename?: 'ReferralProductStatsForReferrer', numberOfReferredMembers: number, pointsEarned: number } } };

export type HighnoteExternalAccountFragmentFragment = { __typename?: 'HighnoteExternalAccountResponse', highnoteExternalAccountId: string, bankAccountLast4?: string | null, bankName?: string | null, accountName?: string | null, accountSubtype?: string | null };

export type GetIncomingScheduledTransfersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIncomingScheduledTransfersQuery = { __typename?: 'Query', incomingScheduledTransfers: { __typename?: 'IncomingScheduledTransfersResponse', page: Array<{ __typename: 'OneTimeAchTransferResponse', id: string, status?: ScheduledTransferStatusCode | null, scheduledTransferDate?: string | null, transferAmount?: { __typename: 'ManualTransferAmountResponse', renderedAmount: { __typename?: 'RenderedAmountResponse', amount: string, currencyCode: string } } | { __typename: 'TransferAmountCalculationResponse', calculatedType: CalculatedTransferAmountType } | null, fromHighnoteExternalAccount?: { __typename?: 'HighnoteExternalAccountResponse', highnoteExternalAccountId: string, bankAccountLast4?: string | null, bankName?: string | null, accountName?: string | null, accountSubtype?: string | null } | null } | { __typename: 'RecurringAchTransferResponse', id: string, status?: ScheduledTransferStatusCode | null, nextScheduledTransferDate?: string | null, transferAmount?: { __typename: 'ManualTransferAmountResponse', renderedAmount: { __typename?: 'RenderedAmountResponse', amount: string, currencyCode: string } } | { __typename: 'TransferAmountCalculationResponse', calculatedType: CalculatedTransferAmountType } | null, fromHighnoteExternalAccount?: { __typename?: 'HighnoteExternalAccountResponse', highnoteExternalAccountId: string, bankAccountLast4?: string | null, bankName?: string | null, accountName?: string | null, accountSubtype?: string | null } | null }> } };

export type CardActivityFeedFragment = { __typename?: 'CardActivityFeedResponse', page: Array<{ __typename: 'CardActivityCardPayment', achTransferId: string, sourceCreatedAt: string, amount: string, transferStatus: TransferStatus } | { __typename: 'CardActivityFinancialEvent', sourceCreatedAt: string, amount: string, description?: string | null, financialEventId: string, financialEventType: FinancialEventType } | { __typename: 'CardActivityStatementCredit', statementCreditId: string, amount: string, name?: string | null, sourceCreatedAt: string, highnoteFinancialAccountTransferStatus?: InterFinancialAccountTransferStatus | null, statementCreditType: StatementCreditType } | { __typename: 'CardActivityTransactionEvent', transactionEventId: string, sourceCreatedAt: string, transactionProcessingType: CardTransactionProcessingType, transactionEventType: TransactionEventType, renderedAmount: { __typename?: 'RenderedAmountResponse', amount: string, currencyCode: string }, merchantDetails?: { __typename?: 'MerchantDetailsResponse', description?: string | null, name?: string | null } | null, pointsEarn?: Array<{ __typename?: 'TransactionEventPointsEarn', points: number, pending: boolean, reason: string }> | null }> };

export type GetPendingActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingActivitiesQuery = { __typename?: 'Query', cardActivityFeed: { __typename?: 'CardActivityFeedResponse', page: Array<{ __typename: 'CardActivityCardPayment', achTransferId: string, sourceCreatedAt: string, amount: string, transferStatus: TransferStatus } | { __typename: 'CardActivityFinancialEvent', sourceCreatedAt: string, amount: string, description?: string | null, financialEventId: string, financialEventType: FinancialEventType } | { __typename: 'CardActivityStatementCredit', statementCreditId: string, amount: string, name?: string | null, sourceCreatedAt: string, highnoteFinancialAccountTransferStatus?: InterFinancialAccountTransferStatus | null, statementCreditType: StatementCreditType } | { __typename: 'CardActivityTransactionEvent', transactionEventId: string, sourceCreatedAt: string, transactionProcessingType: CardTransactionProcessingType, transactionEventType: TransactionEventType, renderedAmount: { __typename?: 'RenderedAmountResponse', amount: string, currencyCode: string }, merchantDetails?: { __typename?: 'MerchantDetailsResponse', description?: string | null, name?: string | null } | null, pointsEarn?: Array<{ __typename?: 'TransactionEventPointsEarn', points: number, pending: boolean, reason: string }> | null }> } };

export type GetPostedActivitiesQueryVariables = Exact<{
  cursor?: InputMaybe<CardActivityFeedCursorInput>;
  orderBy?: InputMaybe<CardActivityOrderByWithRelationInput>;
}>;


export type GetPostedActivitiesQuery = { __typename?: 'Query', cardActivityFeed: { __typename?: 'CardActivityFeedResponse', page: Array<{ __typename: 'CardActivityCardPayment', achTransferId: string, sourceCreatedAt: string, amount: string, transferStatus: TransferStatus } | { __typename: 'CardActivityFinancialEvent', sourceCreatedAt: string, amount: string, description?: string | null, financialEventId: string, financialEventType: FinancialEventType } | { __typename: 'CardActivityStatementCredit', statementCreditId: string, amount: string, name?: string | null, sourceCreatedAt: string, highnoteFinancialAccountTransferStatus?: InterFinancialAccountTransferStatus | null, statementCreditType: StatementCreditType } | { __typename: 'CardActivityTransactionEvent', transactionEventId: string, sourceCreatedAt: string, transactionProcessingType: CardTransactionProcessingType, transactionEventType: TransactionEventType, renderedAmount: { __typename?: 'RenderedAmountResponse', amount: string, currencyCode: string }, merchantDetails?: { __typename?: 'MerchantDetailsResponse', description?: string | null, name?: string | null } | null, pointsEarn?: Array<{ __typename?: 'TransactionEventPointsEarn', points: number, pending: boolean, reason: string }> | null }> } };

export type GetTransactionEventDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTransactionEventDetailsQuery = { __typename?: 'Query', transactionEventDetails: { __typename?: 'TransactionEventDetailsResponse', referenceNumber?: string | null, createdAt: string, transactionProcessingType: CardTransactionProcessingType, type: TransactionEventType, merchantDetails?: { __typename?: 'MerchantDetailsResponse', name?: string | null, category?: MerchantCategory | null, description?: string | null, address?: { __typename?: 'Address', streetAddress?: string | null, extendedAddress?: string | null, locality?: string | null, region?: string | null, postalCode?: string | null, countryCodeAlpha3?: string | null } | null } | null, renderedAmount: { __typename?: 'RenderedAmountResponse', amount: string, currencyCode: string }, pointsEarns?: Array<{ __typename?: 'PointsEarnResponse', points: number, reason: string }> | null } };

export type GetApplicationSubmissionScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationSubmissionScreenQuery = { __typename?: 'Query', getApplicationSubmissionScreen: ApplicationSubmissionScreen };

export type GetCardProductApplicationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCardProductApplicationStatusQuery = { __typename?: 'Query', getCardProductApplicationStatus: { __typename?: 'IGetCardProductApplicationStatusObjectType', paymentCardId?: string | null, status?: string | null } };

export type GetCreditLineInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditLineInformationQuery = { __typename?: 'Query', getCreditLineInformation: { __typename?: 'IGetAccountHolderCardProductApplicationObjectType', apr: number, creditLine: number } };

export type ApplyForCreditCardProductMutationVariables = Exact<{
  input: ApplyForCreditCardProductRequestDto;
}>;


export type ApplyForCreditCardProductMutation = { __typename?: 'Mutation', applyForCreditCardProduct: { __typename?: 'ApplyForCreditCardProductResponseDto', status: string, message: string } };

export type ConfirmCreditReportUnfrozenMutationVariables = Exact<{ [key: string]: never; }>;


export type ConfirmCreditReportUnfrozenMutation = { __typename?: 'Mutation', confirmCreditReportUnfrozen: ApplicationSubmissionScreen };

export type ValidateOfferCodeForCardApplicationQueryVariables = Exact<{
  offerCode: Scalars['String']['input'];
}>;


export type ValidateOfferCodeForCardApplicationQuery = { __typename?: 'Query', validateOfferCodeForCardApplication: { __typename?: 'ValidateOfferCodeForCardApplicationResponse', referralCode?: string | null, isValid: boolean, message?: string | null } };

export type CreateRecurringPaymentMutationVariables = Exact<{
  highnoteExternalAccountId: Scalars['String']['input'];
  transferAmountStrategy: TransferBalanceAmountCode;
  transferDayOfMonth: Scalars['Int']['input'];
  consentTimestamp: Scalars['String']['input'];
}>;


export type CreateRecurringPaymentMutation = { __typename?: 'Mutation', createRecurringPaymentV2: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError', message: string } };

export type GetRecurringScheduledPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecurringScheduledPaymentQuery = { __typename?: 'Query', getRecurringScheduledPayment: { __typename?: 'FindSchedulePaymentResponse', transferAmountStrategy?: CalculatedTransferAmountType | null, nextScheduledTransferDate?: string | null, schedulePaymentId?: string | null, transferSourceAccount?: { __typename?: 'Account', id: string, last4: string, bankName: string, accountName: string, accountSubtype: string } | null } };

export type CreateOneTimePaymentMutationVariables = Exact<{
  highnoteExternalAccountId: Scalars['String']['input'];
  consentTimestamp: Scalars['String']['input'];
  paymentAmount: Scalars['String']['input'];
  transferDate: Scalars['String']['input'];
}>;


export type CreateOneTimePaymentMutation = { __typename?: 'Mutation', createOneTimePaymentV2: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError', message: string } };

export type AddNotificationDeviceMutationVariables = Exact<{
  os: Scalars['String']['input'];
  model: Scalars['String']['input'];
  year: Scalars['String']['input'];
  expoPushToken: Scalars['String']['input'];
  devicePushToken: Scalars['String']['input'];
}>;


export type AddNotificationDeviceMutation = { __typename?: 'Mutation', addNotificationDevice: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError' } };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  settings: Scalars['JSONObject']['input'];
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: { __typename: 'MesaGenericOk', status: MesaGenericOkStatus } | { __typename: 'MesaUserError', message: string } };

export type UpdateNotificationPushStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  pushNotificationStatus: UserPushNotificationStatus;
}>;


export type UpdateNotificationPushStatusMutation = { __typename?: 'Mutation', updateNotificationPushStatus: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError' } };

export type UpdateAllNotificationsPushStatusToMutationVariables = Exact<{
  pushNotificationStatus: UserPushNotificationStatus;
}>;


export type UpdateAllNotificationsPushStatusToMutation = { __typename?: 'Mutation', updateAllNotificationsPushStatusTo: { __typename: 'MesaGenericOk' } | { __typename: 'MesaUserError' } };

export type SettingsItemsFragment = { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean };

export type GetNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', getNotificationSettings: { __typename?: 'GetNotificationSettingsResponse', settings: { __typename?: 'NotificationSettings', card: { __typename?: 'CardCategory', pending_transactions: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, approved_transactions: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, declined_transactions: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, payment_received: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, payment_failures: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean } }, marketing: { __typename?: 'MarketingCategory', new_benefits: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, new_rewards: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, mesa_mortgage: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean } }, announcements: { __typename?: 'AnnouncementsCategory', new_app_features: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean }, milestones: { __typename?: 'CategorySettingsTypes', push_notification: boolean, email: boolean } } } } };

export type GetUserNotificationsQueryVariables = Exact<{
  cursor?: InputMaybe<UserNotificationCursorInput>;
  pushNotificationStatus?: InputMaybe<UserPushNotificationStatus>;
}>;


export type GetUserNotificationsQuery = { __typename?: 'Query', getUserNotifications: { __typename: 'GetUserNotificationsResponse', notifications: Array<{ __typename: 'Notifications', id: string, title: string, body: string, createdAt: string, pushNotificationStatus: UserPushNotificationStatus, deepLinkPath?: string | null }> } };

export type RedeemPointsForMortgageTransferMutationVariables = Exact<{
  numPoints: Scalars['Int']['input'];
  plaidAccountId: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  mortgageAddressId: Scalars['String']['input'];
}>;


export type RedeemPointsForMortgageTransferMutation = { __typename?: 'Mutation', redeemPointsForMortgageTransfer: { __typename?: 'RedeemPointsForMortgageTransferResponsDto', plaidTransferAuthorizationId: string } };

export type CreateMortgageAddressMutationVariables = Exact<{
  input: CreateMortgageAddressRequestDto;
}>;


export type CreateMortgageAddressMutation = { __typename?: 'Mutation', addMortgageAddress: { __typename?: 'AddMortgageAddressResponseDto', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string, country: string } };

export type GetMortgageAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMortgageAddressesQuery = { __typename?: 'Query', getMortgageAddresses: { __typename?: 'GetMortgageAddressesResponseDto', addresses: Array<{ __typename?: 'MortgageAddress', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string, country: string, plaidAccount?: { __typename?: 'PlaidAccountResponse', plaidAccountId: string, accountName: string, bankAccountLast4: string, bankName: string } | null }> } };

export type GetMortgageRedemptionMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMortgageRedemptionMetricsQuery = { __typename?: 'Query', getCashForMortgageRedemptionMetrics: { __typename?: 'CashForMortgageRedemptionMetricsResponse', totalPointsRedeemed: number, totalAmountCents: number, isEligible: boolean, remainingMonthlyCents: number } };

export type RewardsGetPointsLedgerPageQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RewardsGetPointsLedgerPageQuery = { __typename?: 'Query', getPointsLedgerPage: { __typename?: 'PointsLedgerPage', nextCursor: string, hasMore: boolean, items: Array<{ __typename: 'CardPurchasePointsLedgerItem', merchantName: string, pointsMultiplier: number, id: string, isPending: boolean, date: string, canViewDetails: boolean, transactionAmount: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number }, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'CardReturnPointsLedgerItem', merchantName: string, pointsMultiplier: number, id: string, isPending: boolean, date: string, canViewDetails: boolean, transactionAmount: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number }, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'ExternalRedemptionPointsLedgerItem', orderDescription: string, id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'ExternalRedemptionRefundPointsLedgerItem', orderDescription: string, id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'GoodwillPointsLedgerItem', notes?: string | null, id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'LoyaltyTierEventPointsLedgerItem', reason: string, eventDate: string, id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'MesaMortgageLoanPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'MortgageLoanPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'MortgageSpendPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'MortgageTransferPointsLedgerItem', status: string, id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'PromoCodeBonusPointsLedgerItem', promoCode?: string | null, id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'ReferralBonusPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'StatementCreditRedemptionPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, amount: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number }, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'SunsetFlushPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'UnknownEarnPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } } | { __typename: 'UnknownSpendPointsLedgerItem', id: string, isPending: boolean, date: string, canViewDetails: boolean, points: { __typename?: 'PointsLedgerAmount', value: number, decimalPlaces: number, isNegative: boolean } }> } };

export type SurveysGetAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveysGetAvailableQuery = { __typename?: 'Query', availableSurveys: { __typename?: 'AvailableSurveys', items: Array<{ __typename?: 'Survey', id: string }> } };

export type RecordSurveyResponseMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
  responseType: UserSurveyResponseType;
  responseData?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type RecordSurveyResponseMutation = { __typename?: 'Mutation', recordSurveyResponse: { __typename?: 'AvailableSurveys', items: Array<{ __typename?: 'Survey', id: string }> } };

export type GenerateManageCardClientTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateManageCardClientTokenMutation = { __typename?: 'Mutation', generateManageCardClientToken: { __typename?: 'HighnoteClientToken', clientToken: string } };

export const HighnoteExternalAccountFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighnoteExternalAccountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighnoteExternalAccountResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highnoteExternalAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountLast4"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountSubtype"}}]}}]} as unknown as DocumentNode<HighnoteExternalAccountFragmentFragment, unknown>;
export const CardActivityFeedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardActivityFeed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFeedResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityTransactionEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"renderedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionProcessingType"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionEventType"},"name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityCardPayment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achTransferId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityStatementCredit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statementCreditId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"statementCreditType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"highnoteFinancialAccountTransferStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFinancialEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"financialEventId"}},{"kind":"Field","name":{"kind":"Name","value":"financialEventType"}}]}}]}}]}}]} as unknown as DocumentNode<CardActivityFeedFragment, unknown>;
export const SettingsItemsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsItems"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategorySettingsTypes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"push_notification"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<SettingsItemsFragment, unknown>;
export const GenerateClientTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateClientToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateClientToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientToken"}}]}}]}}]} as unknown as DocumentNode<GenerateClientTokenMutation, GenerateClientTokenMutationVariables>;
export const GetUnreadNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnreadNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pushNotificationStatus"},"value":{"kind":"EnumValue","value":"RECEIVED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>;
export const RefreshAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tokenType"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const JoinWaitlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinWaitlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinWaitlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<JoinWaitlistMutation, JoinWaitlistMutationVariables>;
export const VerifyCardInviteCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyCardInviteCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verifyCardInviteCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCardInviteCodeRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyCardInviteCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"verifyCardInviteCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifyCardInviteCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verificationSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"verificationCodeType"}}]}}]}}]} as unknown as DocumentNode<VerifyCardInviteCodeMutation, VerifyCardInviteCodeMutationVariables>;
export const GenerateStatementPdfLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateStatementPdfLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateStatementPdfLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statementId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GenerateStatementPdfLinkMutation, GenerateStatementPdfLinkMutationVariables>;
export const ActivatePaymentCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivatePaymentCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatePaymentCard"}}]}}]} as unknown as DocumentNode<ActivatePaymentCardMutation, ActivatePaymentCardMutationVariables>;
export const RedeemPointsForStatementCreditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedeemPointsForStatementCredit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numPoints"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemPointsForStatementCredit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"redeemPointsForStatementCreditRequestDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"numPoints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numPoints"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}}]}}]}]}}]} as unknown as DocumentNode<RedeemPointsForStatementCreditMutation, RedeemPointsForStatementCreditMutationVariables>;
export const AddPaymentCardToApplePayByDevicePushProvisioningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addPaymentCardToApplePayByDevicePushProvisioning"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplePayPushProvisioningRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPaymentCardToApplePayByDevicePushProvisioning"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"encryptedPassData"}},{"kind":"Field","name":{"kind":"Name","value":"activationData"}},{"kind":"Field","name":{"kind":"Name","value":"ephemeralPublicKey"}}]}}]}}]} as unknown as DocumentNode<AddPaymentCardToApplePayByDevicePushProvisioningMutation, AddPaymentCardToApplePayByDevicePushProvisioningMutationVariables>;
export const CompletePlaidLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"completePlaidLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkSuccessInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completePlaidLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"linkSuccessInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CompletePlaidLinkMutation, CompletePlaidLinkMutationVariables>;
export const RequestOtpCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestOTPCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestOTPCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestOtpCodeDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requested"}}]}}]}}]} as unknown as DocumentNode<RequestOtpCodeMutation, RequestOtpCodeMutationVariables>;
export const ValidateOtpCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateOTPCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otpCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateOtpCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validateOtpCode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otpCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otpCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tokenType"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<ValidateOtpCodeMutation, ValidateOtpCodeMutationVariables>;
export const UpdateUserInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourcePartnerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userInformation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourcePartnerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourcePartnerName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userTrackingFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cardInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastFour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcePartnerName"}}]}}]}}]} as unknown as DocumentNode<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;
export const SendPhoneVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPhoneVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPhoneVerificationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sendPhoneVerificationCodeDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SendPhoneVerificationCodeMutation, SendPhoneVerificationCodeMutationVariables>;
export const SendPhoneVerificationCodeForNewAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPhoneVerificationCodeForNewAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPhoneVerificationCodeForNewAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sendPhoneVerificationCodeDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendPhoneVerificationCodeError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SendPhoneVerificationCodeForNewAccountMutation, SendPhoneVerificationCodeForNewAccountMutationVariables>;
export const ValidatePhoneVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidatePhoneVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatePhoneVerificationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validatePhoneVerificationCodeDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ValidatePhoneVerificationCodeMutation, ValidatePhoneVerificationCodeMutationVariables>;
export const UpdateUserAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"street1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"street2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserAddress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"street1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"street1"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"street2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"street2"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"zipCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}}}]}}]}]}}]} as unknown as DocumentNode<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const ValidateAndUpdateHighnoteAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateAndUpdateHighnoteAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streetAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extendedAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locality"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateHighnoteAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validateAddressRequestDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"streetAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streetAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"extendedAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extendedAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressValidationOutcome"}},{"kind":"Field","name":{"kind":"Name","value":"standarizedStreetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"standarizedExtendedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"standarizedRegion"}},{"kind":"Field","name":{"kind":"Name","value":"standarizedLocality"}},{"kind":"Field","name":{"kind":"Name","value":"standarizedPostalCode"}}]}}]}}]} as unknown as DocumentNode<ValidateAndUpdateHighnoteAddressMutation, ValidateAndUpdateHighnoteAddressMutationVariables>;
export const UpdateAppsFlyerIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAppsFlyerId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appsFlyerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setAppsFlyerId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appsFlyerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appsFlyerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateAppsFlyerIdMutation, UpdateAppsFlyerIdMutationVariables>;
export const GetWaitlistStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWaitlistStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWaitlistStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWaitlisted"}}]}}]}}]} as unknown as DocumentNode<GetWaitlistStatusQuery, GetWaitlistStatusQueryVariables>;
export const GetCreditCardInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreditCardInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCreditCardInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"virtualCardIdForPhysicalCard"}},{"kind":"Field","name":{"kind":"Name","value":"physicalCardTrackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"financialAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"creditOutstanding"}},{"kind":"Field","name":{"kind":"Name","value":"availableCredit"}},{"kind":"Field","name":{"kind":"Name","value":"accountHodlerCreditLimit"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingBalancePayable"}},{"kind":"Field","name":{"kind":"Name","value":"currentAmountDue"}},{"kind":"Field","name":{"kind":"Name","value":"statementPaymentDueOn"}},{"kind":"Field","name":{"kind":"Name","value":"statementBalance"}},{"kind":"Field","name":{"kind":"Name","value":"statementMinimumPayment"}},{"kind":"Field","name":{"kind":"Name","value":"statementPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"statementPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCardAPR"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCardCreditLine"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCardNextClosingDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCreditCardInformationQuery, GetCreditCardInformationQueryVariables>;
export const GetCardOrderInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCardOrderInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCardOrderInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}}]}}]}}]}}]} as unknown as DocumentNode<GetCardOrderInformationQuery, GetCardOrderInformationQueryVariables>;
export const GenerateDocumentUploadClientTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateDocumentUploadClientToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateDocumentUploadClientToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighnoteDocumentUploadClientTokenSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientTokenValue"}},{"kind":"Field","name":{"kind":"Name","value":"documentUploadSessionId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighnoteDocumentUploadClientTokenUnavailable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerateDocumentUploadClientTokenQuery, GenerateDocumentUploadClientTokenQueryVariables>;
export const GetLinkedExternalBankAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkedExternalBankAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Products"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLinkedExternalBankAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highnoteExternalAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"plaidAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"products"}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkedExternalBankAccountsQuery, GetLinkedExternalBankAccountsQueryVariables>;
export const GetStatementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStatements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statementId"}},{"kind":"Field","name":{"kind":"Name","value":"statementDate"}}]}}]}}]} as unknown as DocumentNode<GetStatementsQuery, GetStatementsQueryVariables>;
export const GetMortgageLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMortgageLeads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMortgageLeads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetMortgageLeadsQuery, GetMortgageLeadsQueryVariables>;
export const GetMesaHomeEnrollmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMesaHomeEnrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mesaHomeEnrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnrolled"}},{"kind":"Field","name":{"kind":"Name","value":"recognizedMortgageAmount"}},{"kind":"Field","name":{"kind":"Name","value":"awardSource"}},{"kind":"Field","name":{"kind":"Name","value":"canUserEditAwardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"statementSpend"}},{"kind":"Field","name":{"kind":"Name","value":"statementSpendRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"statementCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"errorDisplayMessage"}}]}}]}}]} as unknown as DocumentNode<GetMesaHomeEnrollmentQuery, GetMesaHomeEnrollmentQueryVariables>;
export const GenerateLinkTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateLinkToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Products"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAndroid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateLinkToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isAndroid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAndroid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}}]} as unknown as DocumentNode<GenerateLinkTokenQuery, GenerateLinkTokenQueryVariables>;
export const GenerateLinkTokenForMortgageEarnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateLinkTokenForMortgageEarn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAndroid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateLinkToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Transactions"}]}},{"kind":"Argument","name":{"kind":"Name","value":"isAndroid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAndroid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}}]}}]} as unknown as DocumentNode<GenerateLinkTokenForMortgageEarnQuery, GenerateLinkTokenForMortgageEarnQueryVariables>;
export const GetPlaidLinkedAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaidLinkedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mask"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"institutionName"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"consentedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"billedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"availableProducts"}},{"kind":"Field","name":{"kind":"Name","value":"verificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isTransactionsActive"}},{"kind":"Field","name":{"kind":"Name","value":"isAuthActive"}}]}}]}}]} as unknown as DocumentNode<GetPlaidLinkedAccountsQuery, GetPlaidLinkedAccountsQueryVariables>;
export const GetUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userTrackingFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastFour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redeemedCardInviteCode"}},{"kind":"Field","name":{"kind":"Name","value":"referralCode"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePartnerName"}}]}}]}}]} as unknown as DocumentNode<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const CheckPhoneNumberIsAvailableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckPhoneNumberIsAvailable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPhoneNumberIsAvailable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumberIsAvailable"}}]}}]}}]} as unknown as DocumentNode<CheckPhoneNumberIsAvailableQuery, CheckPhoneNumberIsAvailableQueryVariables>;
export const CancelScheduledTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelScheduledTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledTransferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelScheduledTransfer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scheduledTransferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledTransferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CancelScheduledTransferMutation, CancelScheduledTransferMutationVariables>;
export const CloseLinkedExternalBankAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"closeLinkedExternalBankAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highnoteExternalAccountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plaidAccountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeLinkedExternalBankAccountV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"highnoteExternalAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highnoteExternalAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plaidAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plaidAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CloseLinkedExternalBankAccountMutation, CloseLinkedExternalBankAccountMutationVariables>;
export const GeoLookupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeoLookup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geoLookup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InferredGeolocationModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeolocationInferenceFailedModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]} as unknown as DocumentNode<GeoLookupQuery, GeoLookupQueryVariables>;
export const CreateMagicLinkToLogIntoRedemptionPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMagicLinkToLogIntoRedemptionPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectPath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMagicLinkToLogIntoRedemptionPortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"redirectPath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectPath"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginLink"}}]}}]}}]} as unknown as DocumentNode<CreateMagicLinkToLogIntoRedemptionPortalMutation, CreateMagicLinkToLogIntoRedemptionPortalMutationVariables>;
export const GetPointsBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPointsBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPointsBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lifetimeEarned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lifetimeSpent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetPointsBalanceQuery, GetPointsBalanceQueryVariables>;
export const GetReferralStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReferralStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferralStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CARD"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfReferredMembers"}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarned"}}]}}]}}]}}]} as unknown as DocumentNode<GetReferralStatsQuery, GetReferralStatsQueryVariables>;
export const GetIncomingScheduledTransfersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIncomingScheduledTransfers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomingScheduledTransfers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneTimeAchTransferResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transferAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManualTransferAmountResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransferAmountCalculationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledTransferDate"}},{"kind":"Field","name":{"kind":"Name","value":"fromHighnoteExternalAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighnoteExternalAccountFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecurringAchTransferResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transferAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManualTransferAmountResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransferAmountCalculationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextScheduledTransferDate"}},{"kind":"Field","name":{"kind":"Name","value":"fromHighnoteExternalAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighnoteExternalAccountFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighnoteExternalAccountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighnoteExternalAccountResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highnoteExternalAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountLast4"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountSubtype"}}]}}]} as unknown as DocumentNode<GetIncomingScheduledTransfersQuery, GetIncomingScheduledTransfersQueryVariables>;
export const GetPendingActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPendingActivities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardActivityFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transactionEventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PaymentCardAuthorizationApprovedEvent"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cardPayment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"},{"kind":"EnumValue","value":"PROCESSING"},{"kind":"EnumValue","value":"INITIATED"}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statementCredit"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"highnoteFinancialAccountTransferStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"}]}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"88"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardActivityFeed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardActivityFeed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFeedResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityTransactionEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"renderedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionProcessingType"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionEventType"},"name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityCardPayment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achTransferId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityStatementCredit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statementCreditId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"statementCreditType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"highnoteFinancialAccountTransferStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFinancialEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"financialEventId"}},{"kind":"Field","name":{"kind":"Name","value":"financialEventType"}}]}}]}}]}}]} as unknown as DocumentNode<GetPendingActivitiesQuery, GetPendingActivitiesQueryVariables>;
export const GetPostedActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostedActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFeedCursorInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityOrderByWithRelationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardActivityFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transactionEventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"EnumValue","value":"PaymentCardAuthorizationApprovedEvent"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"financialEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"NullValue"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cardPayment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"},{"kind":"EnumValue","value":"PROCESSING"},{"kind":"EnumValue","value":"INITIATED"}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statementCredit"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"highnoteFinancialAccountTransferStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SUCCEEDED"}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardActivityFeed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardActivityFeed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFeedResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityTransactionEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"renderedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionProcessingType"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionEventType"},"name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityCardPayment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achTransferId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityStatementCredit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statementCreditId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"statementCreditType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"highnoteFinancialAccountTransferStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardActivityFinancialEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"financialEventId"}},{"kind":"Field","name":{"kind":"Name","value":"financialEventType"}}]}}]}}]}}]} as unknown as DocumentNode<GetPostedActivitiesQuery, GetPostedActivitiesQueryVariables>;
export const GetTransactionEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionEventDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transactionEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"merchantDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"extendedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCodeAlpha3"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"renderedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionProcessingType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetTransactionEventDetailsQuery, GetTransactionEventDetailsQueryVariables>;
export const GetApplicationSubmissionScreenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApplicationSubmissionScreen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getApplicationSubmissionScreen"}}]}}]} as unknown as DocumentNode<GetApplicationSubmissionScreenQuery, GetApplicationSubmissionScreenQueryVariables>;
export const GetCardProductApplicationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCardProductApplicationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCardProductApplicationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentCardId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetCardProductApplicationStatusQuery, GetCardProductApplicationStatusQueryVariables>;
export const GetCreditLineInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreditLineInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCreditLineInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apr"}},{"kind":"Field","name":{"kind":"Name","value":"creditLine"}}]}}]}}]} as unknown as DocumentNode<GetCreditLineInformationQuery, GetCreditLineInformationQueryVariables>;
export const ApplyForCreditCardProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyForCreditCardProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyForCreditCardProductRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyForCreditCardProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applyForCreditCardProduct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ApplyForCreditCardProductMutation, ApplyForCreditCardProductMutationVariables>;
export const ConfirmCreditReportUnfrozenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmCreditReportUnfrozen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmCreditReportUnfrozen"}}]}}]} as unknown as DocumentNode<ConfirmCreditReportUnfrozenMutation, ConfirmCreditReportUnfrozenMutationVariables>;
export const ValidateOfferCodeForCardApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateOfferCodeForCardApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateOfferCodeForCardApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offerCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralCode"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ValidateOfferCodeForCardApplicationQuery, ValidateOfferCodeForCardApplicationQueryVariables>;
export const CreateRecurringPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRecurringPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highnoteExternalAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferAmountStrategy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferBalanceAmountCode"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferDayOfMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consentTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecurringPaymentV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"highnoteExternalAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highnoteExternalAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"transferAmountStrategy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferAmountStrategy"}}},{"kind":"Argument","name":{"kind":"Name","value":"transferDayOfMonth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferDayOfMonth"}}},{"kind":"Argument","name":{"kind":"Name","value":"consentTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentTimestamp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>;
export const GetRecurringScheduledPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecurringScheduledPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecurringScheduledPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferAmountStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"nextScheduledTransferDate"}},{"kind":"Field","name":{"kind":"Name","value":"transferSourceAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountSubtype"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedulePaymentId"}}]}}]}}]} as unknown as DocumentNode<GetRecurringScheduledPaymentQuery, GetRecurringScheduledPaymentQueryVariables>;
export const CreateOneTimePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneTimePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highnoteExternalAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consentTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentAmount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTimePaymentV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"highnoteExternalAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highnoteExternalAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"consentTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentAmount"}}},{"kind":"Argument","name":{"kind":"Name","value":"transferDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneTimePaymentMutation, CreateOneTimePaymentMutationVariables>;
export const AddNotificationDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNotificationDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"os"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expoPushToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"devicePushToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNotificationDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"os"},"value":{"kind":"Variable","name":{"kind":"Name","value":"os"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expoPushToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expoPushToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"devicePushToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"devicePushToken"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddNotificationDeviceMutation, AddNotificationDeviceMutationVariables>;
export const UpdateNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settings"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaGenericOk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MesaUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const UpdateNotificationPushStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationPushStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pushNotificationStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserPushNotificationStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationPushStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pushNotificationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pushNotificationStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationPushStatusMutation, UpdateNotificationPushStatusMutationVariables>;
export const UpdateAllNotificationsPushStatusToDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAllNotificationsPushStatusTo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pushNotificationStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserPushNotificationStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAllNotificationsPushStatusTo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pushNotificationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pushNotificationStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateAllNotificationsPushStatusToMutation, UpdateAllNotificationsPushStatusToMutationVariables>;
export const GetNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pending_transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approved_transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declined_transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_received"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_failures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new_benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"new_rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mesa_mortgage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"announcements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new_app_features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsItems"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsItems"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategorySettingsTypes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"push_notification"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const GetUserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserNotificationCursorInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pushNotificationStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserPushNotificationStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"pushNotificationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pushNotificationStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pushNotificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"deepLinkPath"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const RedeemPointsForMortgageTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedeemPointsForMortgageTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numPoints"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plaidAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mortgageAddressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemPointsForMortgageTransfer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"redeemPointsForMortgageTransferRequestDto"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"numPoints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numPoints"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plaidAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plaidAccountId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"idempotencyKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotencyKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mortgageAddressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mortgageAddressId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plaidTransferAuthorizationId"}}]}}]}}]} as unknown as DocumentNode<RedeemPointsForMortgageTransferMutation, RedeemPointsForMortgageTransferMutationVariables>;
export const CreateMortgageAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMortgageAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMortgageAddressRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMortgageAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addMortgageAddressRequestDto"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<CreateMortgageAddressMutation, CreateMortgageAddressMutationVariables>;
export const GetMortgageAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMortgageAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMortgageAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"plaidAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plaidAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountLast4"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMortgageAddressesQuery, GetMortgageAddressesQueryVariables>;
export const GetMortgageRedemptionMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMortgageRedemptionMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCashForMortgageRedemptionMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPointsRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"isEligible"}},{"kind":"Field","name":{"kind":"Name","value":"remainingMonthlyCents"}}]}}]}}]} as unknown as DocumentNode<GetMortgageRedemptionMetricsQuery, GetMortgageRedemptionMetricsQueryVariables>;
export const RewardsGetPointsLedgerPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RewardsGetPointsLedgerPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPointsLedgerPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPending"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"decimalPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"isNegative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"canViewDetails"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoodwillPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardPurchasePointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantName"}},{"kind":"Field","name":{"kind":"Name","value":"pointsMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"transactionAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"decimalPlaces"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardReturnPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantName"}},{"kind":"Field","name":{"kind":"Name","value":"pointsMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"transactionAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"decimalPlaces"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalRedemptionPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderDescription"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalRedemptionRefundPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderDescription"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatementCreditRedemptionPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"decimalPlaces"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MortgageTransferPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromoCodeBonusPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTierEventPointsLedgerItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"eventDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}}]}}]}}]} as unknown as DocumentNode<RewardsGetPointsLedgerPageQuery, RewardsGetPointsLedgerPageQueryVariables>;
export const SurveysGetAvailableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveysGetAvailable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableSurveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SurveysGetAvailableQuery, SurveysGetAvailableQueryVariables>;
export const RecordSurveyResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordSurveyResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trigger"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSurveyResponseType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordSurveyResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trigger"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trigger"}}},{"kind":"Argument","name":{"kind":"Name","value":"responseType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseType"}}},{"kind":"Argument","name":{"kind":"Name","value":"responseData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RecordSurveyResponseMutation, RecordSurveyResponseMutationVariables>;
export const GenerateManageCardClientTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateManageCardClientToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateManageCardClientToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientToken"}}]}}]}}]} as unknown as DocumentNode<GenerateManageCardClientTokenMutation, GenerateManageCardClientTokenMutationVariables>;